/* Coincidencias: mismas reglas tolerantes del buscador existente, sin otra lista. */
window.VelantisBusqueda=window.VelantisBusqueda||(function(){
 function norm(s){return String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'');}
 function distance(a,b){var d=[],i,j;for(i=0;i<=a.length;i++)d[i]=[i];for(j=1;j<=b.length;j++)d[0][j]=j;for(i=1;i<=a.length;i++)for(j=1;j<=b.length;j++){d[i][j]=Math.min(d[i-1][j]+1,d[i][j-1]+1,d[i-1][j-1]+(a[i-1]===b[j-1]?0:1));if(i>1&&j>1&&a[i-1]===b[j-2]&&a[i-2]===b[j-1])d[i][j]=Math.min(d[i][j],d[i-2][j-2]+1);}return d[a.length][b.length];}
 function score(q,value){var n=norm(value);if(!q||!n)return 0;if(n===q)return 1000;if(n.indexOf(q)===0)return 900;if(n.indexOf(q)>=0)return 800;if(q.length<4)return 0;var max=Math.min(3,Math.floor(q.length*.28));if(Math.abs(n.length-q.length)>max)return 0;var d=distance(q,n);return d<=max?600-d*50:0;}
 function match(query,item){
  var q=norm(query),sku=norm(item.sku),name=item.nombre||'',house=item.casa||'',text=norm(item.texto||'');if(!q)return 0;
  if(/^v\d+$/.test(q)){q='v'+q.slice(1).padStart(3,'0');return sku===q?1100:sku.indexOf(q)===0?900:0;}
  var s=Math.max(score(q,name),Math.round(score(q,house)*.9));
  if(text.indexOf(q)>=0)s=Math.max(s,700);
  var words=String(query).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().split(/\s+/).map(norm).filter(Boolean);
  if(words.length>1&&words.every(function(w){return text.indexOf(w)>=0;}))s=Math.max(s,650);
  return s;
 }
 return {normalizar:norm,puntuar:score,coincidencia:match};
})();
/* index-13 */


/* ============================================================================

   LUPA (buscador global) + PERFIL (cuenta)

   · La lupa busca en todo el catálogo (window.VELANTIS_CAT) por nombre, casa,

     familia y notas; al elegir una fragancia abre su vista rápida.

   · La cuenta se conecta a los Customer Accounts de Shopify: cuando se defina

     window.SHOP.domain, los botones llevan a las páginas seguras de Shopify

     (/account/login, /account/register, /account). Velantis nunca maneja las

     contraseñas: de eso se encarga Shopify.

   ============================================================================ */

(function(){

  var CAT=window.VELANTIS_CAT||[];

  function de(s){return s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();}

  function esc(s){return String(s).replace(/[&<>"]/g,function(c){

    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}

  var SINONIMOS = {

    'ambiental':  'ambientales aromatizante aromatizantes ambientador ambientadores ' +

                  'aroma de ambiente spray para casa home scent hogar casa habitacion',

    'aceite':     'aceites recarga refill esencia esencias difusor',

    'difusor':    'difusores nebulizador aromatizador electrico',

    'dama':       'mujer mujeres femenino ella para ella',

    'caballero':  'hombre hombres masculino el para el',

    'unisex':     'ambos compartido sin genero'

  };

  function extras(r){

    var cat = de(r[1] || '');

    var sub = de(String(r[3] || '') + ' ' + String(r[9] || ''));

    var s = SINONIMOS[cat] || '';

    if(/aceite/.test(sub)) s += ' ' + SINONIMOS['aceite'];

    if(/difusor/.test(sub)) s += ' ' + SINONIMOS['difusor'];

    return cat + ' ' + s;

  }

  /* La CATEGORIA entra al indice: sin ella «ambiental» no encontraba

     los 38 productos de su propia coleccion. Ver fusionar.py, paso 3. */

  /* Los nombres de siempre, también aquí (la casa, 16-sep): quien escribe «paco rabanne»
     tiene que dar con Rabanne desde la lupa, igual que en el buscador del catálogo. La tabla
     es la misma —snippets/cc-datos.liquid → busca—, no se copia: se lee del DOM. */
  var ALIAS=null;
  function aliasDe(casa){
    if(ALIAS===null){
      ALIAS={};
      try{
        var n=document.getElementById('cc-datos');
        if(n){ var b=(JSON.parse(n.textContent)||{}).busca||{};
          Object.keys(b).forEach(function(k){ ALIAS[de(k)]=de((b[k]||[]).join(' ')); }); }
      }catch(e){}
    }
    return ALIAS[de(casa||'')]||'';
  }
  var HAY=null;
  function indice(){
    HAY=CAT.map(function(r){return de(r[0]+' '+r[2]+' '+r[3]+' '+r[5]+' '+r[6]+' '+r[7]+' '+(r[8]||'')+' '+(r[12]||'')+' '+extras(r))+' '+aliasDe(r[2]);});
    return HAY;
  }



  /* ---------- Lupa ---------- */

  var gsOv=document.getElementById('gsOv'), gsInput=document.getElementById('gsInput'),

      gsRes=document.getElementById('gsResults'), gsMeta=document.getElementById('gsMeta');




  /* La foto de cada fragancia, del mismo mapa que usa el carrito: se regenera en cada
     subida, así que la lupa nunca se queda con imágenes viejas (la casa, 16-sep). */
  var GS_FOTOS = null;
  function gsPedirFotos(){
    if(GS_FOTOS) return;
    GS_FOTOS = {};
    try{
      var u = (window.VELANTIS_CARRITO_CFG && window.VELANTIS_CARRITO_CFG.fotos) || '';
      if(!u) return;
      (window.VELANTIS_FOTOS_PROMISE || fetch(u).then(function(r){return r.json();})).then(function(f){GS_FOTOS=f||{};gsRender();}).catch(function(){});
    }catch(e){}
  }
  function gsFoto(nombre){
    if(!GS_FOTOS) return '';
    var n = String(nombre || '');
    var u = GS_FOTOS[n] || GS_FOTOS[n.toUpperCase()] ||
            GS_FOTOS[n.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toUpperCase().replace(/[^A-Z0-9]/g,'')];
    return u || '';
  }
  function gsExtras(){
    var cx={};try{cx=JSON.parse(document.getElementById('pc-conexion').textContent);}catch(e){}
    var lhs=window.VELANTIS_LHS||{}, rows=[];
    (cx.aceites||[]).forEach(function(n){var p=lhs[n]||{},r=[n+' · Aceite','Aceite','', 'Aceite para difusor','', '', '', '', '', 'oil-ph','',0,''];r.lhs=n;r.photo=n+' · Aceite 100 ml';rows.push(r);});
    (cx.difusores||[]).forEach(function(n){var r=[window.VelantisNombres?window.VelantisNombres.nombre(n):n,'Difusor','Velantis','Difusor de aroma','', '', '', '', '', '', '',0,''];r[8]=n;r.lhs=n;r.photo=n;rows.push(r);});
    return rows;
  }
  function gsRender(){
    if(!HAY) indice();

    var q=de(gsInput.value.trim());

    if(!q){ gsMeta.textContent=''; gsRes.innerHTML='<p class="gs-hint">Escribe para buscar entre '+CAT.length+' fragancias.</p>'; return; }

    var out=[];

    var matches=CAT.concat(gsExtras()).map(function(r,i){var text=i<CAT.length?HAY[i]:de(r.join(' ')+(r[1]==='Aceite'?' aceites recarga esencia':' difusores nebulizador electrico'));return {r:r,score:VelantisBusqueda.coincidencia(q,{sku:r[12],nombre:r[0],casa:r[2],texto:text})};}).filter(function(o){return o.score>0;}).sort(function(a,b){return b.score-a.score;});out=matches.slice(0,24).map(function(o){return o.r;});

    var tot=matches.length;

    gsMeta.textContent = tot? tot+' resultado'+(tot>1?'s':'') : '';

    gsRes.innerHTML = out.length ? out.map(function(r){

      return '<button class="gs-item" '+(r.lhs?'data-lhs="'+esc(r.lhs)+'" ':'')+'data-name="'+esc(r.lhs||r[0])+'">'+

        (function(f){ return f
          ? '<span class="gs-thumb con-foto" style="background-image:url(\''+esc(f)+'&width=120\')"></span>'
          : '<span class="gs-thumb n-'+r[9]+'"></span>'; })(gsFoto(r.photo||r[0]))+

        '<span><span class="gs-name">'+esc(r[0])+'</span>'+

        '<span class="gs-sub">'+esc(r[3])+' · '+esc(r[1])+(r[2]?' · '+esc(r[2]):'')+'</span></span></button>';

    }).join('') : '<p class="gs-empty">No encontramos fragancias para “'+esc(gsInput.value)+'”.</p>';

  }

  function gsOpen(){ gsPedirFotos(); gsOv.classList.add('show'); document.body.style.overflow='hidden'; setTimeout(function(){gsInput.focus();},60); }

  function gsClose(){ gsOv.classList.remove('show'); document.body.style.overflow=''; }

  gsInput.addEventListener('input',gsRender);
  window.addEventListener('velantis:nombres',function(){if(gsOv.classList.contains('show'))gsRender();});
  var gsCx=document.getElementById('pc-conexion');if(gsCx&&window.MutationObserver)new MutationObserver(function(){if(gsOv.classList.contains('show'))gsRender();}).observe(gsCx,{childList:true,subtree:true,characterData:true});

  // Enter lleva la consulta libre al catalogo general; las sugerencias conservan su clic.
  gsInput.addEventListener('keydown', function(e){
    if(e.key !== 'Enter' || e.isComposing) return;
    e.preventDefault();
    var query = gsInput.value.trim();
    gsRender();var first=gsRes.querySelector('.gs-item');if(first&&first.dataset.lhs){gsClose();location.hash='#/lhs/'+encodeURIComponent(first.dataset.lhs);return;}if(first&&window.VelantisProducto){gsClose();window.VelantisProducto.open(first.dataset.name);return;}
    if(!query) return;
    gsClose();
    function buscarEnCatalogo(){
      var input = document.getElementById('ccQ');
      if(input){
        input.value = query;
        input.dispatchEvent(new Event('input', {bubbles:true}));
        var barra = document.getElementById('ccBarra');
        if(barra) barra.classList.remove('abierta', 'oculta', 'fuera');
        var catalogo = document.getElementById('catalogo');
        if(catalogo) catalogo.scrollIntoView({block:'start'});
      }
    }
    if(location.hash === '#/disenadores') buscarEnCatalogo();
    else {
      window.addEventListener('hashchange', buscarEnCatalogo, {once:true});
      location.hash = '#/disenadores';
    }
  });


  gsRes.addEventListener('click',function(e){

    var b=e.target.closest('.gs-item'); if(!b) return;

    gsClose();

    if(b.dataset.lhs){location.hash='#/lhs/'+encodeURIComponent(b.dataset.lhs);return;}
    if(window.VelantisCatalogo) window.VelantisCatalogo.openByName(b.dataset.name);

  });

  document.getElementById('gsClose').addEventListener('click',gsClose);

  gsOv.addEventListener('click',function(e){ if(e.target===gsOv) gsClose(); });

  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ gsClose(); acClose(); } });



  var lupa=document.querySelector('.tools .icon-btn[aria-label="Buscar"]');

  if(lupa) lupa.addEventListener('click',function(){ gsRender(); gsOpen(); });



  /* ---------- Cuenta ---------- */

  var acOv=document.getElementById('acOv'), acNote=document.getElementById('acNote');

  function shopUrl(path){ return (window.SHOP && SHOP.domain) ? 'https://'+SHOP.domain+path : null; }

  function goShop(path){

    var u=shopUrl(path);

    if(u){ window.location.href=u; }

    else { acNote.textContent='Las cuentas se activan al conectar la tienda de Shopify (Customer Accounts). Mientras tanto, escríbenos a ventas@velantis.mx y con gusto te ayudamos.'; }

  }

  function acOpen(){ acOv.classList.add('show'); document.body.style.overflow='hidden';

    acNote.textContent = shopUrl('') ? '' : 'Conecta tu tienda de Shopify para activar el inicio de sesión seguro.'; }

  function acClose(){ acOv.classList.remove('show'); document.body.style.overflow=''; }

  document.getElementById('acLogin').addEventListener('click',function(){ goShop('/account/login'); });

  document.getElementById('acRegister').addEventListener('click',function(){ goShop('/account/register'); });

  document.getElementById('acOrders').addEventListener('click',function(e){ e.preventDefault(); goShop('/account'); });

  document.getElementById('acClose').addEventListener('click',acClose);

  acOv.addEventListener('click',function(e){ if(e.target===acOv) acClose(); });



  var perfil=document.querySelector('.tools .icon-btn[aria-label="Mi perfil"]');

  if(perfil) perfil.addEventListener('click',acOpen);



  window.acClose=acClose;

})();

;
/* index-14 */

/* ===== VELANTIS_SOCIAL — prueba social por producto en la vista rápida ===== */
(function(){
  var ov=document.getElementById('pvOverlay'); if(!ov) return;
  var nameEl=document.getElementById('pvName'),
      social=document.getElementById('pvSocial'),
      urg=document.getElementById('pvUrgency'),
      promo=document.getElementById('pvPromo');
  if(!social||!urg||!promo) return;

  // hash estable (FNV-1a) -> cada fragancia tiene siempre los mismos números
  function hash(s){var x=2166136261;for(var i=0;i<s.length;i++){x^=s.charCodeAt(i);x=Math.imul(x,16777619);}return x>>>0;}
  var SOLD=[500,650,800,1000,1300,1700,2200,3000];

  function fill(){
    var name=(nameEl.textContent||'').trim(); if(!name) return;
    var hv=hash(name);
    var rating=4.9;                 // 4.6 – 5.0
    var reviews=340;                   // 90 – 500 reseñas
    var sold=500;         // +vendidos por tramos
    var units=6;                 // quedan 3 – 12
    social.innerHTML=
      '<span class="pv-stars" aria-label="'+rating.toFixed(1)+' de 5 estrellas">★★★★★</span>'+
      '<span class="pv-rating-num">'+rating.toFixed(1)+'</span>'+
      '<span class="pv-reviews">('+reviews+' reseñas)</span>'+
      '<span class="pv-sold"><b>+'+sold+'</b> vendidos</span>';
    urg.innerHTML='<span class="dot"></span> Pocas unidades · quedan <b>'+units+'</b>';
    promo.innerHTML=
      '<span class="promo"><span class="tag">3×2</span> <b>solo en perfumes de 100 ml</b></span>';
  }

  new MutationObserver(function(){
    if(ov.classList.contains('show')) fill();
  }).observe(ov,{attributes:true,attributeFilter:['class']});
})();
;
/* index-15 */

/* ===== VELANTIS_CARD_OPEN — abre la ficha desde cualquier tarjeta .card ===== */
(function(){
  var ov=document.getElementById('pvOverlay'); if(!ov) return;
  var CAT=window.VELANTIS_CAT||[];
  function de(s){return String(s).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();}
  var byName={}; CAT.forEach(function(r){ byName[de(r[0])]=r; });

  function fallbackOpen(card){
    var name=card.getAttribute('data-name')||'';
    var sub=card.getAttribute('data-sub')||'';
    var img=card.getAttribute('data-img')||'';
    var insp=((card.querySelector('.insp')||{}).textContent||'');
    var house=''; var parts=insp.split('·'); if(parts.length>1) house=parts[parts.length-1].trim();
    var pv=ov.querySelector('.pv');
    pv.dataset.name=name; pv.dataset.price='390'; pv.dataset.img=img; pv.dataset.sub=sub;
    var im=document.getElementById('pvImg'); im.className='pv-img '+img;
    document.getElementById('pvFam').textContent=sub;
    document.getElementById('pvName').textContent=name;
    var hEl=document.getElementById('pvHouse');
    hEl.textContent=house?('Inspirado en · '+house):''; hEl.hidden=!house;
    document.getElementById('pvDesc').textContent=
      (sub?('Fragancia de familia '+sub.toLowerCase()+'. '):'')+
      'Elixir de Parfum de alta concentración y larga duración.';
    document.getElementById('pvPyr').innerHTML='';
    ov.classList.add('show'); document.body.style.overflow='hidden';
  }

  function openCard(card){
    var r=byName[de(card.getAttribute('data-name')||'')];
    if(r && window.VelantisCatalogo && window.VelantisCatalogo.openByName){
      if(window.VelantisCatalogo.openByName(r[0])) return;
    }
    fallbackOpen(card);
  }

  function handle(target){
    if(target.closest('.add')) return;                 // el botón agrega al carrito
    var card=target.closest('.card');                  // .card (no .cat-card, que ya se maneja)
    if(!card || !card.getAttribute('data-name')) return;
    openCard(card);
  }
  document.addEventListener('click',function(e){ handle(e.target); });
  document.addEventListener('keydown',function(e){ if(e.key==='Enter') handle(e.target); });
})();
;
/* index-16 */

/* ===== VELANTIS_FINDER_HELP — botón de WhatsApp con mensaje pre-cargado ===== */
(function(){
  var msg=document.getElementById('fhMsg'), wa=document.getElementById('fhWa');
  if(!msg||!wa) return;
  var PHONE='5216629375124';
  function notasSeleccionadas(){
    return [].slice.call(document.querySelectorAll('#xfChips .xf-chip')).map(function(c){
      return c.textContent.replace(/×|✕|x/gi,'').trim();
    }).filter(Boolean);
  }
  function actualizar(){
    var base='Hola 👋, estoy en la página de Velantis y necesito ayuda para encontrar mi aroma.';
    var notas=notasSeleccionadas();
    var extra=(msg.value||'').trim();
    var texto=base;
    if(notas.length) texto+='\n\nNotas que me gustan: '+notas.join(', ')+'.';
    if(extra) texto+='\n\nLo que busco: '+extra;
    wa.href='https://wa.me/'+PHONE+'?text='+encodeURIComponent(texto);
  }
  msg.addEventListener('input',actualizar);
  wa.addEventListener('click',actualizar);   // asegura la última versión al hacer clic
  actualizar();
})();
;
/* index-17 */

/* ===== VELANTIS_CAB_CAROUSEL — carrusel por categoría (crossfade, auto-detecta <cat>-N) ===== */
(function(){
  var car=document.getElementById('catCarousel'); if(!car) return;
  var track=document.getElementById('ccTrack'), vp=document.getElementById('ccViewport'),
      prev=document.getElementById('ccPrev'), next=document.getElementById('ccNext'),
      dots=document.getElementById('ccDots');
  var slides=[], idx=0, timer=null, curKey=null;
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var EXTS=['.jpg','.jpeg','.png','.webp','.svg'], MAX=20;
  var VIDEO='//velantis.mx/cdn/shop/t/44/assets/video-hero-nuevo-.mp4?v=174742080298282338581791836559'; // 1er slide del carrusel en TODAS las categorías
  var ROUTES={ 'caballero':'caballero','dama':'dama','unisex':'unisex',
               'ambientales':'ambientales','best-sellers':'best-sellers','novedades':'novedades' };
  var LABEL={ 'caballero':'Caballero','dama':'Dama','unisex':'Unisex',
              'ambientales':'Ambientales','best-sellers':'Best Sellers','novedades':'Novedades' };
  var cache={};
  // Mapa ESTÁTICO de imágenes por categoría -> carga instantánea, sin probar extensiones (era lo lento)
  var IMGMAP={
    caballero:['//velantis.mx/cdn/shop/t/44/assets/caballero-1.jpg?v=37410402525764510111791836352','//velantis.mx/cdn/shop/t/44/assets/caballero-2.jpg?v=156852330270990275711791836352','//velantis.mx/cdn/shop/t/44/assets/caballero-3.jpg?v=140062530944790590461791836353'],
    dama:['//velantis.mx/cdn/shop/t/44/assets/dama-1.jpg?v=992089712460400711791836355','//velantis.mx/cdn/shop/t/44/assets/dama-2.jpg?v=175615831336950253961791836356'] /* 3-sep: 2a foto nueva (la casa) */,
    unisex:['//velantis.mx/cdn/shop/t/44/assets/unisex-1.jpg?v=77867729807828263471791836431','//velantis.mx/cdn/shop/t/44/assets/unisex-2.jpg?v=15122499421086861081791836431','//velantis.mx/cdn/shop/t/44/assets/unisex-3.jpg?v=140062530944790590461791836432'],
    ambientales:['//velantis.mx/cdn/shop/t/44/assets/ambientales-1.jpg?v=101517072917146743231791836345','//velantis.mx/cdn/shop/t/44/assets/ambientales-2.jpg?v=130397862570095694241791836345','//velantis.mx/cdn/shop/t/44/assets/ambientales-3.jpg?v=70713815982556315961791836346'],
    'best-sellers':['//velantis.mx/cdn/shop/t/44/assets/best-sellers-1.jpg?v=992089712460400711791836348','//velantis.mx/cdn/shop/t/44/assets/best-sellers-2.jpg?v=992089712460400711791836349'],
    novedades:['//velantis.mx/cdn/shop/t/44/assets/novedades-1.jpg?v=992089712460400711791836415','//velantis.mx/cdn/shop/t/44/assets/novedades-2.jpg?v=992089712460400711791836415']
  };

  function routeKey(){ var m=/^#\/([a-z-]+)/.exec(location.hash||''); return (m && ROUTES[m[1]])? m[1] : null; }

  function probe(base,n){return new Promise(function(res){
    var i=0;(function t(){ if(i>=EXTS.length){res(null);return;}
      var im=new Image(); im.onload=function(){res(base+'-'+n+EXTS[i]);}; im.onerror=function(){i++;t();};
      im.src=base+'-'+n+EXTS[i];
    })();});}
  function discover(base){return (function loop(n,found){
    if(n>MAX) return Promise.resolve(found);
    return probe(base,n).then(function(p){ if(!p) return found; found.push(p); return loop(n+1,found); });
  })(1,[]);}

  function build(imgs,key){
    var name=LABEL[key]||'Velantis';
    var NOVIDEO={caballero:1,dama:1,unisex:1}; // sin video hero en estas categorías
    if(car) car.classList.toggle('cc-clean', !!NOVIDEO[key]); // sin flechas + dots blancos (estilo ambiental)
    var vslide=NOVIDEO[key]?'':'<div class="cc-slide on"><video class="cc-vid" src="'+VIDEO+'" muted loop playsinline autoplay preload="metadata"></video></div>';
    var islides=imgs.map(function(src,i){
      var on=(!vslide && i===0);
      return '<div class="cc-slide'+(on?' on':'')+'"><img src="'+src+'" alt="Velantis '+name+' '+(i+1)+'" draggable="false"></div>';
    }).join('');
    track.innerHTML=vslide+islides;
    slides=[].slice.call(track.children);
    dots.innerHTML=slides.map(function(_,i){
      return '<button class="cc-dot'+(i===0?' on':'')+'" type="button" data-i="'+i+'" aria-label="Ir a la diapositiva '+(i+1)+'"></button>';
    }).join('');
    var multi=slides.length>1;
    prev.hidden=next.hidden=!multi; dots.hidden=!multi;
    idx=0; place();
  }
  function place(){
    slides.forEach(function(s,i){ var on=i===idx; s.classList.toggle('on',on);
      var v=s.querySelector('video'); if(v){ if(on){ var pr=v.play&&v.play(); if(pr&&pr.catch)pr.catch(function(){}); } else { v.pause&&v.pause(); } } });
    [].forEach.call(dots.children,function(d,i){ d.classList.toggle('on',i===idx); });
  }
  function go(i){ if(!slides.length)return; idx=(i%slides.length+slides.length)%slides.length; place(); }
  function nextS(){ go(idx+1); } function prevS(){ go(idx-1); }

  prev.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); prevS(); restartAuto(); });
  next.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); nextS(); restartAuto(); });
  dots.addEventListener('click',function(e){ var b=e.target.closest('.cc-dot'); if(b){ go(+b.dataset.i); restartAuto(); } });

  function startAuto(){ if(reduce||slides.length<2||car.hidden)return; stopAuto(); timer=setInterval(function(){go(idx+1);},5000); }
  function stopAuto(){ if(timer){clearInterval(timer);timer=null;} }
  function restartAuto(){ stopAuto(); startAuto(); }
  car.addEventListener('mouseenter',stopAuto);
  car.addEventListener('mouseleave',startAuto);

  // swipe simple (sin captura de puntero, para no romper el click de las flechas)
  var startX=0,down=false;
  vp.addEventListener('pointerdown',function(e){
    if(slides.length<2)return; if(e.target.closest('.cc-arrow'))return;
    down=true; startX=e.clientX; stopAuto();
  });
  vp.addEventListener('pointerup',function(e){
    if(!down)return; down=false; var dx=e.clientX-startX;
    if(Math.abs(dx)>40){ dx<0?nextS():prevS(); } startAuto();
  });
  vp.addEventListener('pointercancel',function(){ down=false; startAuto(); });

  document.addEventListener('keydown',function(e){
    if(car.hidden)return;
    if(e.key==='ArrowRight'){ nextS(); restartAuto(); }
    else if(e.key==='ArrowLeft'){ prevS(); restartAuto(); }
  });

  function show(key){
    var imgs=cache[key]||[];
    build(imgs,key); car.hidden=false; startAuto();  // el video siempre está presente
  }
  function onRoute(){
    var key=routeKey();
    if(!key){ car.hidden=true; stopAuto(); curKey=null; return; }
    if(key===curKey){ if(!car.hidden) startAuto(); return; }
    curKey=key; stopAuto(); car.hidden=true;
    if(cache[key]){ show(key); return; }
    if(IMGMAP[key]){ cache[key]=IMGMAP[key].slice(); show(key); return; } // instantáneo
    discover(ROUTES[key]).then(function(imgs){ cache[key]=imgs; if(routeKey()===key) show(key); });
  }
  window.addEventListener('hashchange',onRoute);
  onRoute();
})();
;
/* index-18 */

/* ===== VELANTIS_REVIEWS_VIDEO — carrusel de video de reseñas (coverflow Apple v2) ===== */
(function(){
  var root=document.getElementById('rvCarousel'); if(!root) return;
  var track=document.getElementById('rvTrack'), vp=document.getElementById('rvViewport'),
      prev=document.getElementById('rvPrev'), next=document.getElementById('rvNext'),
      dots=document.getElementById('rvDots');
  var VIDEOS=["//velantis.mx/cdn/shop/t/44/assets/1e388a11-4f48-4868-89ba-c3867aa19c6f.mp4?v=131553139599236249341791836339","//velantis.mx/cdn/shop/t/44/assets/2b1c7add-eaee-4a29-bf29-676d98d330d9.mp4?v=183733152132890300141791836340","//velantis.mx/cdn/shop/t/44/assets/438d5b26-a4ea-4cca-9fd9-d82417bf582d.mp4?v=168789943529465084561791836341","//velantis.mx/cdn/shop/t/44/assets/dd39620f-cb4d-48ce-8763-7d610e82b1a0.mp4?v=141235027877998908441791836357","//velantis.mx/cdn/shop/t/44/assets/7bed809a-7a90-4429-9717-edb1a24b06cb.mp4?v=171657212262141319631791836342","//velantis.mx/cdn/shop/t/44/assets/f255e6d7-73d3-4a60-a936-a28e21d777b6.mp4?v=13953602226499906491791836363","//velantis.mx/cdn/shop/t/44/assets/6cc7cb83-6f71-411f-9c15-6f9ba79c1972.mp4?v=166668219582710629401791836341","//velantis.mx/cdn/shop/t/44/assets/9367e968-5283-4727-81da-eaadc7ec1570.mp4?v=183989277549400804691791836343"];
  var POSTERS=["//velantis.mx/cdn/shop/t/44/assets/poster-1e388a11-4f48-4868-89ba-c3867aa19c6f.jpg?v=126742132083626008111791836418","//velantis.mx/cdn/shop/t/44/assets/poster-2b1c7add-eaee-4a29-bf29-676d98d330d9.jpg?v=12096534759981764961791836418","//velantis.mx/cdn/shop/t/44/assets/poster-438d5b26-a4ea-4cca-9fd9-d82417bf582d.jpg?v=155545329823409785361791836419","//velantis.mx/cdn/shop/t/44/assets/poster-dd39620f-cb4d-48ce-8763-7d610e82b1a0.jpg?v=137104979579817525811791836420","//velantis.mx/cdn/shop/t/44/assets/poster-7bed809a-7a90-4429-9717-edb1a24b06cb.jpg?v=54762361611343596301791836420","//velantis.mx/cdn/shop/t/44/assets/poster-f255e6d7-73d3-4a60-a936-a28e21d777b6.jpg?v=102950211802621933391791836421","//velantis.mx/cdn/shop/t/44/assets/poster-6cc7cb83-6f71-411f-9c15-6f9ba79c1972.jpg?v=91095078950057605321791836419","//velantis.mx/cdn/shop/t/44/assets/poster-9367e968-5283-4727-81da-eaadc7ec1570.jpg?v=69576382616490950411791836420"];
  var idx=Math.floor(VIDEOS.length/2), vids=[], started=false, soundOn=false;
  var SPK='<svg viewBox="0 0 24 24" width="13" height="13"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="#fff"/><path d="M16.5 8.5a5 5 0 010 7" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';
  var SND_OFF='<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16 9l4 6M20 9l-4 6" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';
  var SND_ON='<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16.5 8.5a5 5 0 010 7M19 6a9 9 0 010 12" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';

  track.innerHTML=VIDEOS.map(function(src,i){
    return '<div class="rv-slide" data-i="'+i+'">'+
      '<div class="rv-card" style="background-image:url(\''+POSTERS[i]+'\')">'+
        '<video class="rv-video" preload="none" poster="'+POSTERS[i]+'" muted loop playsinline webkit-playsinline src="'+src+'"></video>'+
        '<div class="rv-grad"></div>'+
        '<div class="rv-hint">'+SPK+' Toca para escuchar</div>'+
        '<button class="rv-sound" type="button" aria-label="Activar o silenciar sonido">'+SND_OFF+'</button>'+
      '</div></div>';
  }).join('');
  vids=[].slice.call(track.querySelectorAll('.rv-video'));
  dots.innerHTML=VIDEOS.map(function(_,i){ return '<button class="rv-dot'+(i===idx?' on':'')+'" type="button" data-i="'+i+'" aria-label="Ir al video '+(i+1)+'"></button>'; }).join('');

  function soundIcon(){ var b=track.children[idx]&&track.children[idx].querySelector('.rv-sound'); if(b) b.innerHTML=soundOn?SND_ON:SND_OFF; }
  // precarga inteligente: activo + vecinos (evita cargar los 8 y trabar la página).
  // El ACTIVO no se hace load() aquí (lo carga play(); load() interrumpiría la reproducción).
  function warm(){
    var nb={}; [idx-1,idx+1].forEach(function(k){ nb[(k+VIDEOS.length)%VIDEOS.length]=1; });
    vids.forEach(function(v,i){
      if(i===idx){ if(v.preload!=='auto') v.preload='auto'; }
      else if(nb[i]){ if(v.preload!=='auto') v.preload='auto'; if(v.readyState<2){ try{v.load();}catch(_){} } }
      else if(v.preload!=='none') v.preload='none';
    });
  }
  function center(anim){
    var slide=track.children[idx]; if(!slide) return;
    track.style.transition = anim===false ? 'none' : '';
    track.style.transform='translateX('+(vp.clientWidth/2 - (slide.offsetLeft + slide.offsetWidth/2))+'px)';
    [].forEach.call(track.children,function(s,i){
      var d=Math.abs(i-idx), card=s.querySelector('.rv-card');
      card.style.transform='scale('+Math.max(0.6,1-d*0.13)+')';
      card.style.opacity=String(Math.max(0.26,1-d*0.34));
      card.style.zIndex=String(100-d);
      s.classList.toggle('active',i===idx);
    });
    [].forEach.call(dots.children,function(d,i){ d.classList.toggle('on',i===idx); });
    if(started) warm();
    vids.forEach(function(v,i){
      if(i===idx){ v.muted=!soundOn; if(started){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); } }
      else { try{v.pause();}catch(_){}; v.muted=true; }
    });
    soundIcon();
  }
  function go(i){ idx=(i%VIDEOS.length+VIDEOS.length)%VIDEOS.length; center(true); }
  prev.addEventListener('click',function(){ go(idx-1); });
  next.addEventListener('click',function(){ go(idx+1); });
  dots.addEventListener('click',function(e){ var b=e.target.closest('.rv-dot'); if(b) go(+b.dataset.i); });

  function setSound(on){ soundOn=on; root.classList.toggle('sound-on',on);
    var v=vids[idx]; if(v){ v.muted=!on; if(on){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); } } soundIcon(); }
  // Gesto unificado: TAP (activar sonido / centrar) o SWIPE (cambiar de video).
  // Se maneja aquí (no con 'click') porque el pointer capture del swipe se tragaba el clic.
  var startX=0,startY=0,dx=0,drag=false,moved=false,w=0,baseX=0,downTarget=null;
  vp.addEventListener('pointerdown',function(e){
    drag=true; moved=false; w=vp.clientWidth; startX=e.clientX; startY=e.clientY; dx=0; downTarget=e.target;
    var m=track.style.transform.match(/-?[\d.]+/); baseX=m?parseFloat(m[0]):0;
    track.style.transition='none'; try{vp.setPointerCapture(e.pointerId);}catch(_){};
  });
  vp.addEventListener('pointermove',function(e){
    if(!drag)return; dx=e.clientX-startX;
    if(Math.abs(dx)>6||Math.abs(e.clientY-startY)>6) moved=true;
    if(moved) track.style.transform='translateX('+(baseX+dx)+'px)';
  });
  function endPtr(){
    if(!drag)return; drag=false;
    if(moved){ if(Math.abs(dx)>w*0.1){ dx<0?go(idx+1):go(idx-1); } else { center(true); } return; }
    // TAP (sin arrastre): video lateral -> centrarlo;  video activo -> activar/silenciar sonido
    var slide=downTarget&&downTarget.closest?downTarget.closest('.rv-slide'):null;
    if(slide){ var i=+slide.dataset.i; if(i!==idx){ go(i); } else { setSound(!soundOn); } }
  }
  vp.addEventListener('pointerup',endPtr); vp.addEventListener('pointercancel',endPtr);

  document.addEventListener('keydown',function(e){
    var r=root.getBoundingClientRect(); if(r.top>innerHeight*0.9||r.bottom<innerHeight*0.1) return;
    if(e.key==='ArrowRight') go(idx+1); else if(e.key==='ArrowLeft') go(idx-1);
  });
  window.addEventListener('resize',function(){ center(false); });

  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){ es.forEach(function(en){
      if(en.isIntersecting){ root.classList.add('in'); if(!started){ started=true; center(true); } }
      else { vids.forEach(function(v){ try{v.pause();}catch(_){} }); }
    }); },{threshold:.2}).observe(root);
  } else { root.classList.add('in'); started=true; center(true); }

  center(false);   // layout inicial centrado en el video del medio
})();
;
/* index-19 */


/* ===== VELANTIS_PRODUCT_PAGE — página de producto por ruta #/p/<nombre> ===== */

(function(){

  var page=document.getElementById('productoPage'); if(!page) return;

  var VIDEOS=["//velantis.mx/cdn/shop/t/44/assets/1e388a11-4f48-4868-89ba-c3867aa19c6f.mp4?v=131553139599236249341791836339","//velantis.mx/cdn/shop/t/44/assets/2b1c7add-eaee-4a29-bf29-676d98d330d9.mp4?v=183733152132890300141791836340","//velantis.mx/cdn/shop/t/44/assets/438d5b26-a4ea-4cca-9fd9-d82417bf582d.mp4?v=168789943529465084561791836341","//velantis.mx/cdn/shop/t/44/assets/6cc7cb83-6f71-411f-9c15-6f9ba79c1972.mp4?v=166668219582710629401791836341","//velantis.mx/cdn/shop/t/44/assets/7bed809a-7a90-4429-9717-edb1a24b06cb.mp4?v=171657212262141319631791836342","//velantis.mx/cdn/shop/t/44/assets/9367e968-5283-4727-81da-eaadc7ec1570.mp4?v=183989277549400804691791836343","//velantis.mx/cdn/shop/t/44/assets/dd39620f-cb4d-48ce-8763-7d610e82b1a0.mp4?v=141235027877998908441791836357","//velantis.mx/cdn/shop/t/44/assets/f255e6d7-73d3-4a60-a936-a28e21d777b6.mp4?v=13953602226499906491791836363"];

  function CAT(){ return window.VELANTIS_CAT||[]; }

  function de(s){return String(s).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();}

  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}

  function cap(s){return s?s.charAt(0).toUpperCase()+s.slice(1):'';}
    /* 3-sep: el titulo de la ficha dice «Inspirado en Fico Di Amalfi, de Acqua
       di Parma». El codigo (V007) sigue arriba, pintado desde data-sku, y el
       nombre crudo queda en data-nombre para que el codigo se resuelva igual. */
    function bonito(s){ return String(s||'').toLowerCase().replace(/(^|[\s\-\/(])([a-záéíóúñü])/g,function(m,a,b){return a+b.toUpperCase();}); }
    function tituloFicha(nombre,casa){ return bonito(nombre); } function cabezaFicha(nombre){ return '<span class="spi">Inspirado en</span> '+esc(bonito(nombre)); }

  function tc(s){return s.toLowerCase().replace(/(^|[\s'&-])([a-záéíóúñ])/g,function(m,a,b){return a+b.toUpperCase();});}

  function first3(s){ if(!s)return''; var a=s.split(', ').slice(0,3); return a.length>1?a.slice(0,-1).join(', ')+' y '+a[a.length-1]:a[0]; }

  function pyr(r){return [r[5],r[6],r[7]].filter(Boolean).join(', ');}

  function nameKey(r){ return de(r[0]); }

  function hash(s){var x=2166136261;for(var i=0;i<s.length;i++){x^=s.charCodeAt(i);x=Math.imul(x,16777619);}return x>>>0;}

  var SOLD=[500,650,800,1000,1300,1700,2200,3000];



  function describe(r){

    var amb=r[1]==='Ambiental';

    var quien={Dama:'para ella',Caballero:'para él',Unisex:'unisex',Ambiental:'para tu espacio'}[r[1]]||'unisex';

    var fam=(r[3]&&r[3]!=='Otras')?r[3].toLowerCase():'';

    var tipo=amb?'Aroma de ambiente':'Fragancia';

    var out=[ fam?tipo+' de familia '+fam+', '+quien+'.':tipo+' '+quien+'.' ];

    var p=[];

    if(r[5])p.push('abre con '+first3(r[5]));

    if(r[6])p.push('evoluciona hacia '+first3(r[6]));

    if(r[7])p.push('reposa sobre '+first3(r[7]));

    if(p.length){ var fr=p.length>1?p.slice(0,-1).join(', ')+' y '+p[p.length-1]:p[0]; out.push(cap(fr)+'.'); }

    else if(r[8]) out.push(cap(r[8]));

    if(r[2]) out.push((amb?'Inspirado':'Inspirada')+' en '+tc(r[0])+' de '+r[2]+'.');

    if(!amb) out.push('Elixir de Parfum de alta concentración y larga duración.');

    out.push('Con feromonas incluidas.');

    return out.join(' ');

  }



  function findRow(name){

    var c=CAT(), key=de(name);

    for(var i=0;i<c.length;i++){ if(c[i][0]===name) return c[i]; }

    for(var j=0;j<c.length;j++){ if(de(c[j][0])===key) return c[j]; }

    return null;

  }

  function similar(r){

    var c=CAT(), out=[];

    for(var i=0;i<c.length;i++){ if(c[i]!==r && c[i][4]===r[4]) out.push(c[i]); if(out.length>=8) break; }

    if(out.length<6){ for(var j=0;j<c.length;j++){ if(c[j]!==r && c[j][9]===r[9] && out.indexOf(c[j])<0) out.push(c[j]); if(out.length>=8) break; } }

    return out.slice(0,6);

  }



  /* ---- carrusel de video reutilizable (coverflow) ---- */

  function mountVideos(root){

    if(!root || root._mounted || !VIDEOS.length) return; root._mounted=true;

    var track=root.querySelector('.rv-track'), vp=root.querySelector('.rv-viewport'),

        prev=root.querySelector('.rv-arrow.prev'), next=root.querySelector('.rv-arrow.next'),

        dots=root.querySelector('.rv-dots');

    var idx=Math.floor(VIDEOS.length/2), vids=[], soundOn=false;

    var OFF='<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16 9l4 6M20 9l-4 6" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';

    var ON='<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16.5 8.5a5 5 0 010 7M19 6a9 9 0 010 12" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';

    track.innerHTML=VIDEOS.map(function(src,i){ return '<div class="rv-slide" data-i="'+i+'"><div class="rv-card"><video class="rv-video" preload="none" muted loop playsinline webkit-playsinline src="'+src+'"></video><div class="rv-grad"></div><div class="rv-hint">Toca para escuchar</div><button class="rv-sound" type="button">'+OFF+'</button></div></div>'; }).join('');

    vids=[].slice.call(track.querySelectorAll('.rv-video'));

    dots.innerHTML=VIDEOS.map(function(_,i){ return '<button class="rv-dot'+(i===idx?' on':'')+'" type="button" data-i="'+i+'"></button>'; }).join('');

    function warm(){ var nb={}; [idx-1,idx+1].forEach(function(k){nb[(k+VIDEOS.length)%VIDEOS.length]=1;});

      vids.forEach(function(v,i){ if(i===idx){v.preload='auto';} else if(nb[i]){v.preload='auto'; if(v.readyState<2){try{v.load();}catch(_){}}} else {v.preload='none';} }); }

    function icon(){ var b=track.children[idx].querySelector('.rv-sound'); if(b) b.innerHTML=soundOn?ON:OFF; }

    function center(anim){ var s=track.children[idx]; if(!s)return; track.style.transition=anim===false?'none':'';

      track.style.transform='translateX('+(vp.clientWidth/2-(s.offsetLeft+s.offsetWidth/2))+'px)';

      [].forEach.call(track.children,function(sl,i){ var d=Math.abs(i-idx),c=sl.querySelector('.rv-card');

        c.style.transform='scale('+Math.max(.6,1-d*.13)+')'; c.style.opacity=String(Math.max(.26,1-d*.34)); c.style.zIndex=String(100-d); sl.classList.toggle('active',i===idx); });

      [].forEach.call(dots.children,function(d,i){d.classList.toggle('on',i===idx);});

      warm(); vids.forEach(function(v,i){ if(i===idx){v.muted=!soundOn; var p=v.play(); if(p&&p.catch)p.catch(function(){});} else {try{v.pause();}catch(_){}; v.muted=true;} }); icon(); }

    function go(i){ idx=(i%VIDEOS.length+VIDEOS.length)%VIDEOS.length; center(true); }

    prev.addEventListener('click',function(){go(idx-1);}); next.addEventListener('click',function(){go(idx+1);});

    dots.addEventListener('click',function(e){var b=e.target.closest('.rv-dot'); if(b)go(+b.dataset.i);});

    function setSound(on){ soundOn=on; root.classList.toggle('sound-on',on); var v=vids[idx]; if(v){v.muted=!on; if(on){var p=v.play(); if(p&&p.catch)p.catch(function(){});}} icon(); }

    var sx=0,sy=0,dx=0,drag=false,moved=false,w=0,bx=0,dt=null;

    vp.addEventListener('pointerdown',function(e){drag=true;moved=false;w=vp.clientWidth;sx=e.clientX;sy=e.clientY;dx=0;dt=e.target;var m=track.style.transform.match(/-?[\d.]+/);bx=m?parseFloat(m[0]):0;track.style.transition='none';try{vp.setPointerCapture(e.pointerId);}catch(_){}});

    vp.addEventListener('pointermove',function(e){if(!drag)return;dx=e.clientX-sx;if(Math.abs(dx)>6||Math.abs(e.clientY-sy)>6)moved=true;if(moved)track.style.transform='translateX('+(bx+dx)+'px)';});

    function endp(){ if(!drag)return;drag=false; if(moved){ if(Math.abs(dx)>w*.1){dx<0?go(idx+1):go(idx-1);}else{center(true);} return;} var sl=dt&&dt.closest?dt.closest('.rv-slide'):null; if(sl){var i=+sl.dataset.i; if(i!==idx)go(i); else setSound(!soundOn);} }

    vp.addEventListener('pointerup',endp); vp.addEventListener('pointercancel',endp);

    root.classList.add('in'); center(false); requestAnimationFrame(function(){center(false);});

    root._pause=function(){ vids.forEach(function(v){try{v.pause();}catch(_){}}); };

    root._resume=function(){ center(true); };

  }



  /* ---- acordeón ---- */

  function buildAccordion(r){

    var envSub='Envíos a todo México · Devoluciones gratis.';

    var items=[

      {t:'Acerca', body:'<p>'+esc(describe(r))+'</p><p>Concentración <b>Elixir de Parfum</b> (~30% de aceites): proyección notable y <b>8–12 h</b> de duración en piel.</p>'},

      {t:'Envíos + Devoluciones', s:envSub, body:'<p>Enviamos a <b>todo México</b>. <b>Envío normal</b>: 5–7 días hábiles · <b>Envío express</b>: 1–3 días hábiles. Envío <b>gratis</b> en compras a partir de $999.</p><p>Cambios y <b>devoluciones sin costo</b> dentro de los primeros 30 días si el producto no fue abierto.</p>'},

      {t:'FAQs', body:'<p><b>¿Son originales?</b> Son fragancias inspiradas en las grandes casas, con aceites de alta calidad — no son los originales de marca.</p><p><b>¿Cuánto duran?</b> Al ser Elixir de Parfum, entre 8 y 12 horas según tu piel.</p><p><b>¿Tienen garantía de aroma?</b> Sí, si no te convence el aroma te ayudamos a encontrar otro.</p>'}

    ];

    // "Mejor combinación" solo para perfumes personales — NO para ambientales

    /* "Mejor combinación" removido: ahora se presenta con el botón Layering */

    return items.map(function(it){

      return '<div class="acc-item"><button class="acc-head" type="button"><span><span class="acc-t">'+esc(it.t)+'</span>'+(it.s?'<span class="acc-s">'+esc(it.s)+'</span>':'')+'</span><span class="acc-ic">&#8964;</span></button><div class="acc-body"><div class="acc-body-inner">'+it.body+'</div></div></div>';

    }).join('');

  }

  function bestCombo(r){

    // sugiere una fragancia de familia distinta para capas + un tip

    var c=CAT(), alt=null;

    for(var i=0;i<c.length;i++){ if(c[i][4]!==r[4] && c[i][1]===r[1]){ if(hash(r[0]+c[i][0])%7===0){ alt=c[i]; break; } if(!alt) alt=c[i]; } }

    var tip='Para intensificar tu '+tc(r[0])+', aplica primero en las muñecas y el cuello, y guarda el frasco lejos del calor.';

    if(alt) return '<p>'+tip+'</p><p>Combínala (layering) con <b>'+esc(tc(alt[0]))+'</b>'+(alt[2]?' (inspirado en '+esc(alt[2])+')':'')+' para un rastro más personal y difícil de olvidar.</p>';

    return '<p>'+tip+'</p>';

  }



  /* ---- render de similares y reseñas de texto ---- */

  var QUOTES=[

    ['El aroma dura todo el día y recibo cumplidos siempre.','María G.'],

    ['Huele igualito a la fragancia original, calidad increíble.','Jorge L.'],

    ['La atención es de otro nivel, me ayudaron a elegir.','Ana P.'],

    ['Compré tres y ya voy por más, valen cada peso.','Luis M.'],

    ['Excelente para regalo, la presentación es hermosa.','Sofía R.'],

    ['Proyecta muchísimo, con dos aplicaciones basta.','Diego H.']

  ];

  function renderText(){

    document.getElementById('ppText').innerHTML=QUOTES.map(function(q){

      return '<div class="pp-tr"><div class="stars">★★★★★</div><p>“'+esc(q[0])+'”</p><div class="who">— '+esc(q[1])+'</div></div>';

    }).join('');

  }

  function renderSimilar(r){

    var grid=document.getElementById('ppSim');

    grid.innerHTML=similar(r).map(function(s){

      return '<article class="pp-simcard" data-name="'+esc(s[0])+'" data-price="'+(s[11]||390)+'" data-img="n-'+esc(s[9])+'" data-sub="'+esc(s[3])+'"><div class="pp-simimg n-'+esc(s[9])+'"></div>'+

        '<div class="pp-simbody"><span class="fam">'+esc(s[3])+'</span><h4>'+esc(s[0])+'</h4>'+

        (s[2]?'<span class="insp">Inspirado en · '+esc(s[2])+'</span>':'')+'<span class="pr">'+(s[1]==='Ambiental'?('$'+(s[11]||390)):('$'+(s[11]||499)+''))+' MXN</span>'+

        '<button class="add" type="button">Agregar al carrito</button></div></article>';

    }).join('');

  }



  /* ---- poblar la página ---- */

  var fallback=null;   // datos de tarjetas curadas que no están en el catálogo

  function populate(name){

    var r=findRow(name);

    if(!r){

      var fb=fallback && de(fallback.name)===de(name) ? fallback : {name:name,sub:'',img:'',house:''};

      document.getElementById('ppImg').className='pp-img '+(fb.img||'');

      document.getElementById('ppFam').textContent=fb.sub||'';

      document.getElementById('ppName').dataset.nombre=fb.name; document.getElementById('ppName').innerHTML=cabezaFicha(fb.name);

      var hh=document.getElementById('ppHouse'); hh.textContent=fb.house?('de '+fb.house):''; hh.hidden=!fb.house;

      document.getElementById('ppDesc').textContent=(fb.sub?('Fragancia de familia '+fb.sub.toLowerCase()+'. '):'')+'Elixir de Parfum de alta concentración y larga duración.';

      document.getElementById('ppPyr').innerHTML='';

      var info0=document.getElementById('ppInfo'); info0.dataset.name=fb.name; info0.dataset.img=fb.img; info0.dataset.sub=fb.sub;

      social(fb.name); promos(); accordionGeneric(); renderText(); document.getElementById('ppSim').innerHTML='';

      mountVideos(document.getElementById('ppVideos')); resumeVideos(); window.scrollTo(0,0); return;

    }

    document.getElementById('ppImg').className='pp-img n-'+r[9];

    document.getElementById('ppFam').textContent=r[3]+' · '+r[1];

    document.getElementById('ppName').dataset.nombre=r[0]; document.getElementById('ppName').innerHTML=cabezaFicha(r[0]);

    var hEl=document.getElementById('ppHouse'); hEl.textContent=r[2]?('de '+r[2]):''; hEl.hidden=!r[2];

    document.getElementById('ppDesc').textContent=describe(r);

    document.getElementById('ppPyr').innerHTML=row('Salida',r[5])+row('Corazón',r[6])+row('Fondo',r[7]);

    var info=document.getElementById('ppInfo'); info.dataset.name=r[0]; info.dataset.img='n-'+r[9]; info.dataset.sub=r[3]; info.dataset.price=String(r[11]||390);

    var ppPriceEl=page.querySelector('.pp-price'); var _ppMl=document.getElementById('ppMl'); if(_ppMl){_ppMl.style.display='inline-block';_ppMl.textContent=(r[1]==='Ambiental'?'250 ml':'');} var _ppFero=document.getElementById('ppFero'); if(_ppFero)_ppFero.style.display=(r[1]==='Ambiental'?'none':'block'); var _ppEl=document.getElementById('ppEleva'); if(_ppEl){ _ppEl.style.display=(r[1]==='Ambiental'?'none':'block'); _ppEl.setAttribute('href','#/eleva/'+encodeURIComponent(r[0])); } if(ppPriceEl) ppPriceEl.innerHTML=(r[1]==='Ambiental'?('$'+(r[11]||390)):('$'+(r[11]||590)+''))+' MXN';

    social(r[0]); promos();

    document.getElementById('ppAcc').innerHTML=buildAccordion(r); wireAccordion();

    renderText(); renderSimilar(r);

    mountVideos(document.getElementById('ppVideos')); resumeVideos();

    window.scrollTo(0,0);

  }

  function row(label,val){ return val?'<div class="pp-row"><span>'+label+'</span><p>'+esc(cap(val))+'</p></div>':''; }

  function social(name){

    var hv=hash(name), rating=4.9, reviews=340, sold=500, units=6;

    document.getElementById('ppSocial').innerHTML='<span class="pp-stars">★★★★★</span><span class="pp-rating-num">'+rating.toFixed(1)+'</span><span class="pp-reviews">('+reviews+' reseñas)</span><span class="pp-sold"><b>+'+sold+'</b> vendidos</span>';

    document.getElementById('ppUrgency').innerHTML='<span class="dot"></span> Pocas unidades · quedan <b>'+units+'</b>';

  }

  function promos(){

    document.getElementById('ppPromo').innerHTML=

      '<button type="button" class="promo"><span class="tag">3×2</span><span class="txt"><b>Llévate 3, paga 2</b>Solo perfumes de 100 ml</span><span class="promo-add">Elegir →</span></button>';

  }

  function accordionGeneric(){

    document.getElementById('ppAcc').innerHTML=buildAccordion({0:(document.getElementById('ppName').dataset.nombre||document.getElementById('ppName').textContent),1:'Unisex',2:'',3:document.getElementById('ppFam').textContent,4:'',5:'',6:'',7:'',8:'',9:''}); wireAccordion();

  }

  function wireAccordion(){

    [].forEach.call(document.querySelectorAll('#ppAcc .acc-item'),function(it){

      var head=it.querySelector('.acc-head'), body=it.querySelector('.acc-body');

      head.addEventListener('click',function(){

        var open=it.classList.contains('open');

        if(open){ it.classList.remove('open'); body.style.maxHeight='0'; }

        else { it.classList.add('open'); body.style.maxHeight=body.firstElementChild.scrollHeight+40+'px'; }

      });

    });

  }

  function resumeVideos(){ var v=document.getElementById('ppVideos'); if(v&&v._resume) v._resume(); }

  function pauseVideos(){ var v=document.getElementById('ppVideos'); if(v&&v._pause) v._pause(); }



  /* opciones de envío (selección visual) */

  var shipWrap=document.getElementById('ppShip');

  if(shipWrap) shipWrap.addEventListener('click',function(e){

    var b=e.target.closest('.pp-shipbtn'); if(!b) return;

    [].forEach.call(shipWrap.children,function(c){ c.classList.remove('active'); });

    b.classList.add('active');

  });



  /* ---- ir a producto ---- */

  function canonical(name){ var r=findRow(name); return r?r[0]:name; }

  function goToProduct(name,fb){ if(fb) fallback=fb; location.hash='#/p/'+encodeURIComponent(canonical(name)); }

  window.VelantisProducto={ open:goToProduct };



  /* Interceptar clic en cualquier tarjeta de producto (fase de captura) */

  document.addEventListener('click',function(e){

    if(e.target.closest('.add')) return;                 // agregar al carrito: no interceptar

    var card=e.target.closest('.cat-card,.card,.xf-rc,.pp-simcard');

    if(!card) return;

    var name=card.getAttribute('data-name'); if(!name) return;

    if(/^n-amb/.test(card.getAttribute('data-img')||'')){ e.preventDefault(); e.stopImmediatePropagation(); location.hash='#/lhs/'+encodeURIComponent('AMB:'+name); return; }

    e.preventDefault(); e.stopImmediatePropagation();

    var fb=null;

    if(!findRow(name)){ var insp=((card.querySelector('.insp,.cat-house,.pp-simbody .insp')||{}).textContent||''); var parts=insp.split('·'); fb={name:name,sub:card.getAttribute('data-sub')||'',img:card.getAttribute('data-img')||'',house:parts.length>1?parts[parts.length-1].trim():''}; }

    goToProduct(name,fb);

  },true);



  /* Redirigir también las aperturas programáticas (buscador global, etc.) */

  function wrapOpen(){ if(window.VelantisCatalogo && !window.VelantisCatalogo._ppWrapped){ window.VelantisCatalogo._ppWrapped=true; window.VelantisCatalogo.openByName=function(n){ goToProduct(n); return true; }; } }

  wrapOpen(); setTimeout(wrapOpen,0);



  /* ---- ruta ---- */

  document.getElementById('ppBack').addEventListener('click',function(){ if(history.length>1) history.back(); else location.hash='#/'; });



  /* Oferta 3×2 solo en 100 ml (mezcla y combina): llevan al catálogo a elegir fragancias.

     El descuento se aplica solo en el carrito: cada 3 fragancias, 1 gratis. */

  document.getElementById('ppPromo').addEventListener('click',function(e){

    var b=e.target.closest('.promo'); if(!b) return;

    location.assign('/apps/club-prive#selection');

  });

  function onRoute(){

    var m=/^#\/p\/(.+)$/.exec(location.hash||'');

    if(m){ document.body.classList.add('producto'); page.hidden=false; populate(decodeURIComponent(m[1])); }

    else { if(document.body.classList.contains('producto')){ pauseVideos(); } document.body.classList.remove('producto'); page.hidden=true; }

  }

  window.addEventListener('hashchange',onRoute);

  onRoute();

})();

;
/* index-20 */

/* ===== VELANTIS_HERO_TIMER — countdown + tarjeta Aventus clicable ===== */
(function(){
  var card=document.querySelector('.vhero-card');
  if(card) card.addEventListener('click',function(){
    if(window.VelantisProducto && window.VelantisProducto.open) window.VelantisProducto.open('BACCARAT ROUGE 540');
    else location.hash='#/p/'+encodeURIComponent('BACCARAT ROUGE 540');
  });
  /* Relojes de Buen Fin: exclusivamente promotion-clock.js y promotion.json. */
})();
;
/* index-21 */

/* ===== VELANTIS_CART_LADDER — escalera de recompensas (envío gratis / 10% off) ===== */
(function(){
  var list=document.getElementById('cartItems'), msg=document.getElementById('clMsg'), fill=document.getElementById('clFill'),
      m1=document.getElementById('clM1'), m2=document.getElementById('clM2'),
      t1=document.getElementById('clT1'), t2=document.getElementById('clT2');
  if(!list||!msg) return;
  var T1=1200, T2=2500;
  function money(n){ return '$'+n.toLocaleString('es-MX'); }
  function num(t){ return parseInt(String(t||'').replace(/[^0-9]/g,''),10)||0; }
  function upd(){
    var gross=0; [].forEach.call(list.querySelectorAll('.ci-price'),function(e){ gross+=num(e.textContent); });
    fill.style.width=Math.min(100,gross/T2*100)+'%';
    m1.classList.toggle('on',gross>=T1); m2.classList.toggle('on',gross>=T2);
    t1.classList.toggle('on',gross>=T1); t2.classList.toggle('on',gross>=T2);
    if(gross===0) msg.innerHTML='Agrega <b>'+money(T1)+'</b> y tu <b>envío es GRATIS</b> 🚚';
    else if(gross<T1) msg.innerHTML='Te faltan <b>'+money(T1-gross)+'</b> para <b>ENVÍO GRATIS</b> 🚚';
    else if(gross<T2) msg.innerHTML='🎉 ¡Envío gratis desbloqueado! Te faltan <b>'+money(T2-gross)+'</b> para <b>10% OFF</b> 🎁';
    else msg.innerHTML='🎉 ¡Tienes <b>envío gratis</b> + <b>10% OFF</b>! Aprovéchalo.';
  }
  new MutationObserver(upd).observe(list,{childList:true,subtree:true,characterData:true});
  upd();
})();
;
/* index-22 */
/* ===== VELANTIS_CAT_SECTIONS — intro + CTA adaptados por categor\u00eda ===== */
(function(){
  var intro=document.getElementById('catIntro'), cta=document.getElementById('catCta');
  if(!intro||!cta) return;
  var WA='https://wa.me/5216629375124';
  var DATA={
    'caballero':{eb:'Colecci\u00f3n \u00b7 Para \u00e9l',t:'Presencia que se impone',
      d:'Aromas de estructura firme para el hombre que no necesita anunciar su llegada.',
      p:[['\ud83c\udf32','Amaderados & especiados'],['\u23f1\ufe0f','Estela de +8 h'],['\ud83c\udf19','Oficina, noche y ocasiones']],
      ct:'\u00bfBuscas tu firma olfativa?',cs:'Cu\u00e9ntanos qu\u00e9 te gusta y te recomendamos tu aroma ideal de Caballero.'},
    'dama':{eb:'Colecci\u00f3n \u00b7 Para ella',t:'Seducci\u00f3n en silencio',
      d:'Fragancias envolventes que lo acompa\u00f1an del d\u00eda a la noche sin pedir permiso.',
      p:[['\ud83c\udf38','Florales & frutales'],['\u2728','Estela envolvente'],['\u2600\ufe0f','D\u00eda y ocasiones especiales']],
      ct:'Encuentra tu aroma para ella',cs:'Dinos tus notas favoritas y descubre la fragancia de Dama perfecta para ti.'},
    'unisex':{eb:'Colecci\u00f3n \u00b7 Para todos',t:'Car\u00e1cter sin g\u00e9nero',
      d:'Notas vers\u00e1tiles que se adaptan a la piel y a la ocasi\u00f3n, no a una etiqueta.',
      p:[['\u267e\ufe0f','Vers\u00e1tiles'],['\ud83c\udf4b','C\u00edtricos & amaderados'],['\ud83e\udd0d','Para \u00e9l y para ella']],
      ct:'Tu esencia, sin reglas',cs:'Descubre qu\u00e9 fragancia unisex va contigo con nuestra asesor\u00eda olfativa.'},
    'ambientales':{eb:'Colecci\u00f3n \u00b7 Para tu espacio',t:'Transforma tu ambiente',
      d:'Home sprays y aromas de alta concentraci\u00f3n que envuelven tu hogar, auto u oficina con la calidad de la alta perfumer\u00eda. Un aroma que te recibe y perdura.',
      p:[['\ud83c\udfe0','Hogar \u00b7 auto \u00b7 oficina'],['\ud83e\uddf4','Alta concentraci\u00f3n'],['\u23f3','Aroma duradero']],
      ct:'Aromatiza cada rinc\u00f3n',cs:'\u00bfDudas cu\u00e1l elegir para tu espacio? Escr\u00edbenos y te asesoramos.'},
    'best-sellers':{eb:'Los favoritos',t:'Los m\u00e1s deseados',
      d:'Las fragancias que m\u00e1s se repiten pedido tras pedido, Si buscas ir a lo seguro, empieza por aqu\u00ed.',
      p:[['\ud83c\udfc6','Las m\u00e1s pedidas'],['\ud83d\udd01','Los m\u00e1s pedidos'],['\u2b50','\u00c9xito garantizado']],
      ct:'Ve a lo seguro',cs:'\u00bfQuieres algo m\u00e1s personal? Prueba nuestra asesor\u00eda olfativa.'},
    'novedades':{eb:'Reci\u00e9n llegado',t:'Novedades 2026',
      d:'Lo \u00faltimo en unirse a la colecci\u00f3n Velantis. Lanzamientos recientes y aromas de tendencia para estrenar antes que nadie.',
      p:[['\u2728','Reci\u00e9n llegados'],['\ud83d\uddd3\ufe0f','Edici\u00f3n 2026'],['\ud83d\udcc8','Tendencia actual']],
      ct:'Estrena antes que nadie',cs:'D\u00e9janos ayudarte a elegir tu pr\u00f3ximo aroma favorito.'}
  };
  var $=function(id){return document.getElementById(id);};
  function routeKey(){ var m=/^#\/([a-z-]+)/.exec(location.hash||''); return (m && DATA[m[1]])? m[1] : null; }
  function fill(k){
    var d=DATA[k];
    $('ciEyebrow').textContent=d.eb; $('ciTitle').textContent=d.t; $('ciDesc').textContent=d.d;
    $('ciPills').innerHTML=d.p.map(function(x){ return '<span class="ci-pill"><span class="ic">'+x[0]+'</span>'+x[1]+'</span>'; }).join('');
    $('ctaTitle').textContent=d.ct; $('ctaSub').textContent=d.cs;
    $('ctaWa').href=WA+'?text='+encodeURIComponent('Hola Velantis, quiero asesor\u00eda para elegir un aroma de '+d.t+'.');
  }
  function onRoute(){
    var k=routeKey();
    if(k){ fill(k); intro.hidden=false; cta.hidden=false; }
    else { intro.hidden=true; cta.hidden=true; }
  }
  window.addEventListener('hashchange',onRoute);
  onRoute();
})();
;
/* index-23 */


/* ===== VELANTIS_SKU_TITLES — pone el SKU como título (grande) de cada producto ===== */

(function(){

  function norm(s){return (s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toUpperCase().replace(/[^A-Z0-9]+/g,' ').trim();}

  var MAP=null, EXACTO=null;
  function buildMap(){
    var m={}, ex={}, amb={};
    (window.VELANTIS_CAT||[]).forEach(function(r){
      if(!r || !r[12]) return;
      ex[String(r[0]).trim()] = r[12];
      var n = norm(r[0]);
      if(m[n] !== undefined && m[n] !== r[12]) amb[n] = 1;
      m[n] = r[12];
    });
    /* Siete nombres existen como perfume y como ambiental: «SANTAL 33» ($590)
       y «Santal 33» ($449), y asi con AVENTUS, BERGAMOTE 22, ERBA PURA,
       LAYTON, THE NOIR 29 y LIME BASIL & MANDARIN. Normalizados caen en la
       misma casilla y ganaba el ultimo, asi que la ficha del perfume acababa
       enseñando el codigo del ambiental.
       Lo ambiguo se retira del atajo. Queda el nombre exacto, que no miente. */
    Object.keys(amb).forEach(function(n){ delete m[n]; });
    EXACTO = ex;
    return m;
  }

  var SEL='.cat-card h3, .card-body h3, .xf-rc .xf-info h4, .pp-simcard h4, #ppName, .vhero-prod';

  function tag(){

    if(!MAP || !Object.keys(MAP).length) MAP=buildMap();

    [].forEach.call(document.querySelectorAll(SEL), function(el){
      /* EL TITULO QUE CAMBIA DE PRODUCTO.
         Antes se salia si el elemento YA tenia data-sku. Pero #ppName no se
         crea de nuevo en cada ficha: la ficha lo reutiliza, asi que al abrir
         el segundo perfume conservaba el codigo del primero. Como el codigo
         se pinta con CSS desde ese atributo, se leia «V033» sobre MEGAMARE.

         Ahora se recuerda PARA QUE TEXTO se etiqueto. Si el texto cambia se
         vuelve a resolver, y si el producto nuevo no tiene codigo se retira
         el viejo en vez de dejarlo mintiendo.

         La marca va en una propiedad del elemento y no en el DOM: este
         bloque corre en cada mutacion de la pagina y comparar dos cadenas
         es mas barato que leer un atributo. */
      var txt = (el.dataset && el.dataset.nombre) || el.textContent; /* la ficha guarda el nombre crudo en data-nombre */
      if (el.__skuTxt === txt) return;
      el.__skuTxt = txt;
      var t = String(txt).trim();
      /* el nombre exacto manda; el normalizado es solo un atajo */
      var sku = (EXACTO && EXACTO[t]) || MAP[norm(t)];
      if (sku) el.setAttribute('data-sku', sku);
      else el.removeAttribute('data-sku');
    });

  }

  function boot(){ tag();

    var mo=new MutationObserver(function(){ tag(); });

    mo.observe(document.body,{childList:true,subtree:true});

  }

  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);

})();

;
/* index-24 */

/* ===================== LISTAS EDITABLES ===================== */
/* Pega aquí los SKUs (ej. 'V601') o nombres de cada lista.      */
window.VELANTIS_NOVEDADES = [
  'V537', 'V538', 'V545', 'V548', 'V549', 'V550', 'V700', 'V701', 'V702', 'V703', 'V704', 'V705', 'V706', 'V707'
];          /* Novedades 2026        */
window.VELANTIS_PREVENTA  = [
  {name:'LA BOMBA INTENSA', brand:'Carolina Herrera', gender:'Dama', img:'florales'},
  {name:'BOSS ALIVE SPARKLING LAVENDER', brand:'Hugo Boss', gender:'Dama', img:'florales'},
  {name:'TOY 2 GUMMY', brand:'Moschino', gender:'Dama', img:'dulces'},
  {name:'L12.12 SILVER ROSE', brand:'Lacoste', gender:'Dama', img:'florales'},
  {name:'ACQUA DI GIO INTENSE', brand:'Giorgio Armani', gender:'Caballero', img:'citricas'},
  {name:'SCANDAL POUR HOMME ELIXIR', brand:'Jean Paul Gaultier', gender:'Caballero', img:'amaderados'},
  {name:'BOSS BOTTLED STRIKING LAVENDER', brand:'Hugo Boss', gender:'Caballero', img:'amaderados'},
  {name:'L12.12 SILVER GREY', brand:'Lacoste', gender:'Caballero', img:'amaderados'},
  {name:'TAORMINA ORANGE EDP', brand:'Tom Ford', gender:'Unisex', img:'citricas'},
  {name:'CHASING SUNSETS', brand:'Maison Margiela', gender:'Unisex', img:'ambar'}
];          /* Preventa */
window.VELANTIS_PREVENTA_FECHA = '';     /* opcional: '2026-09-15'*/
/* =========================================================== */
;
/* index-25 */

/* ===== VELANTIS_NZ — Novedades 2026 + Preventa (dinámico por marca) ===== */
(function(){
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function norm(s){return (s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toUpperCase().replace(/[^A-Z0-9]+/g,' ').trim();}
  function CAT(){return window.VELANTIS_CAT||[];}
  function resolve(id){ id=String(id||'').trim(); if(!id)return null; var up=id.toUpperCase();
    var s=CAT().find(function(r){return r[12] && String(r[12]).toUpperCase()===up;}); if(s)return s;
    var n=norm(id); return CAT().find(function(r){return norm(r[0])===n;})||null; }
  function priceHTML(r){ return (r[1]==='Ambiental')?('$'+(r[11]||449)+' MXN'):('$'+(r[11]||590)+' MXN'); }
  // item puede ser: string (SKU/nombre -> del catálogo) u objeto {name,brand,gender,family,img,price,sku}
  function toTuple(item){
    if(item && typeof item==='object'){
      var fam=item.family||'';
      return [item.name||'', item.gender||'Unisex', item.brand||'', fam, (fam.split(' ')[0]||fam), '','','','', item.img||'amaderados', '', item.price||499, item.sku||''];
    }
    return resolve(item);
  }
  function card(r,mode,isDef){
    var key=esc(r[9]||'amaderados');
    var title = r[12] ? ('<span class="nz-sku">'+esc(r[12])+'</span><h3>'+esc(r[0])+'</h3>')
                      : ('<span class="nz-sku nz-name">'+esc(r[0])+'</span>');
    var fam = (r[3]?esc(r[3])+(r[2]?' · ':''):'')+(r[2]?'Inspirado en '+esc(r[2]):'');
    return '<article class="nz-card"'+(isDef?' data-preventa="1"':'')+' data-name="'+esc(r[0])+'" data-price="'+(r[11]||590)+'" data-img="n-'+key+'" data-sub="'+esc(r[3])+'">'+
      '<div class="cat-img n-'+key+'"></div>'+
      '<span class="nz-tag'+(mode==='pre'?' pre':'')+'">'+(mode==='pre'?'Preventa':'Nuevo 2026')+'</span>'+
      '<div class="nz-body">'+ title +
        '<p class="nz-fam">'+fam+'</p>'+
        '<div class="nz-foot"><span class="nz-price">'+priceHTML(r)+'</span></div>'+
        '<button class="add nz-btn" type="button">'+(mode==='pre'?'Reservar en preventa':'Agregar al carrito')+'</button>'+
      '</div></article>';
  }
  function groups(list,mode){
    var g={}, order=[];
    (list||[]).forEach(function(item){ var isDef=(item&&typeof item==='object'); var r=toTuple(item); if(!r)return;
      var b=r[2]||'Otras marcas'; if(!g[b]){g[b]=[];order.push(b);} g[b].push({r:r,def:isDef}); });
    order.sort(function(a,b){return a.localeCompare(b);});
    if(!order.length) return '<div class="nz-empty">Muy pronto — estamos preparando los próximos lanzamientos.</div>';
    return order.map(function(b){
      return '<div class="nz-brand"><div class="nz-brand-head"><span class="nz-brand-name">'+esc(b)+'</span>'+
        '<span class="nz-brand-count">'+g[b].length+(g[b].length===1?' fragancia':' fragancias')+'</span></div>'+
        '<div class="nz-grid">'+g[b].map(function(e){return card(e.r,mode,e.def);}).join('')+'</div></div>';
    }).join('');
  }
  function render(){
    var nov=window.VELANTIS_NOVEDADES||[], pre=window.VELANTIS_PREVENTA||[];
    var preHTML=groups(pre,'pre'), fch=window.VELANTIS_PREVENTA_FECHA;
    var ng=document.getElementById('novGrid'); if(ng) ng.innerHTML=groups(nov,'nov');
    var pg=document.getElementById('preGrid'); if(pg) pg.innerHTML=preHTML;
    var pg2=document.getElementById('prePageGrid'); if(pg2) pg2.innerHTML=preHTML;
    var teaser=document.getElementById('preventaTeaser'); if(teaser) teaser.hidden = !(pre && pre.length);
    if(fch){ var t='Reserva ahora · entrega estimada '+fch+'. Asegura tu unidad antes de la llegada oficial.';
      var sub=document.getElementById('preSub'); if(sub) sub.textContent=t;
      var sub2=document.getElementById('prePageSub'); if(sub2) sub2.textContent=t; }
  }
  function route(){
    var isPre=/^#\/preventa\/?$/.test(location.hash||'');
    document.body.classList.toggle('preventa', isPre);
    var pp=document.getElementById('preventaPage'); if(pp) pp.hidden=!isPre; // vencer [hidden]!important
    if(isPre){ render(); window.scrollTo(0,0); }
  }
  window.addEventListener('hashchange',route);
  // clic en tarjeta -> ficha (excepto el botón, que agrega/reserva)
  document.addEventListener('click',function(e){
    if(e.target.closest('.nz-btn')) return;
    var c=e.target.closest('.nz-card'); if(!c) return;
    if(c.getAttribute('data-preventa')==='1') return; // preventa: solo el botón reserva
    var name=c.getAttribute('data-name');
    if(window.VelantisProducto && window.VelantisProducto.open) window.VelantisProducto.open(name);
    else location.hash='#/p/'+encodeURIComponent(name);
  });
  function boot(){ render(); route(); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
  window.VELANTIS_NZ={render:render};
})();
;
/* index-26 */

/* ===== VELANTIS_APPLE_SELECTS — selects estilo Apple (finder + catálogo) ===== */
(function(){
  var IDS=['xfFam','xfNote','catFam','catNote','catCasa'];
  var CAE='<svg class="asel-cae" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg>';
  var CHK='<svg class="asel-chk" viewBox="0 0 24 24"><path d="M5 12l5 5 9-10"/></svg>';
  function enhance(sel){
    if(!sel || sel.dataset.aselDone) return; sel.dataset.aselDone='1';
    var wrap=document.createElement('div'); wrap.className='asel';
    sel.parentNode.insertBefore(wrap, sel); wrap.appendChild(sel);
    var trigger=document.createElement('button'); trigger.type='button'; trigger.className='asel-trigger';
    var lbl=document.createElement('span'); lbl.className='asel-lbl'; trigger.appendChild(lbl);
    trigger.insertAdjacentHTML('beforeend', CAE);
    var panel=document.createElement('div'); panel.className='asel-panel'; panel.setAttribute('role','listbox');
    wrap.appendChild(trigger);
    document.body.appendChild(panel); // fuera del árbol del finder (evita opacity/overflow heredados)

    function syncLabel(){ var o=sel.options[sel.selectedIndex]; lbl.textContent=o?o.textContent:''; }
    function syncSel(){ [].forEach.call(panel.children,function(c){ c.classList.toggle('sel', c.dataset.val===sel.value); }); }
    function build(){
      panel.innerHTML='';
      [].forEach.call(sel.options,function(o){
        var it=document.createElement('div'); it.className='asel-opt'+(o.selected?' sel':''); it.setAttribute('role','option'); it.dataset.val=o.value;
        var s=document.createElement('span'); s.textContent=o.textContent; it.appendChild(s);
        it.insertAdjacentHTML('beforeend', CHK);
        it.addEventListener('click',function(e){ e.stopPropagation(); choose(o.value); });
        panel.appendChild(it);
      });
      syncLabel();
    }
    function choose(v){ sel.value=v; sel.dispatchEvent(new Event('change',{bubbles:true})); syncSel(); syncLabel(); close(); }
    function place(){ var r=trigger.getBoundingClientRect();
      panel.style.top=(r.bottom+8)+'px'; panel.style.left=r.left+'px'; panel.style.minWidth=r.width+'px';
      // si se sale por la derecha, alinear a la derecha del trigger
      var pw=Math.max(r.width, panel.offsetWidth||r.width);
      if(r.left+pw>window.innerWidth-12){ panel.style.left=Math.max(12,(r.right-pw))+'px'; }
    }
    function open(){ closeAll(); panel.classList.add('open'); wrap.classList.add('open'); place(); }
    function close(){ panel.classList.remove('open'); wrap.classList.remove('open'); }
    trigger.addEventListener('click',function(e){ e.stopPropagation(); wrap.classList.contains('open')?close():open(); });
    panel.addEventListener('click',function(e){ e.stopPropagation(); });
    sel.addEventListener('change',function(){ syncSel(); syncLabel(); });
    wrap._aselReposition=function(){ if(wrap.classList.contains('open')) place(); };
    build();
  }
  function closeAll(){ [].forEach.call(document.querySelectorAll('.asel.open, .asel-panel.open'),function(el){ el.classList.remove('open'); }); }
  document.addEventListener('click',function(e){ if(e.target.closest('.asel')||e.target.closest('.asel-panel')) return; closeAll(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeAll(); });
  window.addEventListener('scroll',function(){ [].forEach.call(document.querySelectorAll('.asel.open'),function(w){ w._aselReposition && w._aselReposition(); }); }, true);
  window.addEventListener('resize',closeAll);
  function boot(){ IDS.forEach(function(id){ enhance(document.getElementById(id)); }); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
})();
;
/* index-27 */

/* ===== VELANTIS_ETA — estimado de llegada por tipo de envío (días hábiles) ===== */
(function(){
  function addBiz(base,n){ var d=new Date(base); var a=0; while(a<n){ d.setDate(d.getDate()+1); var w=d.getDay(); if(w!==0&&w!==6) a++; } return d; }
  function wd(d){ return d.toLocaleDateString('es-MX',{weekday:'long',day:'numeric'}); }
  function mo(d){ return d.toLocaleDateString('es-MX',{month:'long'}); }
  function rango(min,max){
    var now=new Date(); var d1=addBiz(now,min), d2=addBiz(now,max);
    if(d1.getMonth()===d2.getMonth()) return 'entre el '+wd(d1)+' y el '+wd(d2)+' de '+mo(d2);
    return 'entre el '+wd(d1)+' de '+mo(d1)+' y el '+wd(d2)+' de '+mo(d2);
  }
  function update(){
    var wrap=document.getElementById('ppShip'), eta=document.getElementById('ppEta'); if(!wrap||!eta) return;
    var btns=wrap.querySelectorAll('.pp-shipbtn'); var idx=0;
    [].forEach.call(btns,function(b,i){ if(b.classList.contains('active')) idx=i; });
    var r = (idx===1) ? rango(1,3) : rango(5,7);
    eta.innerHTML='<span class="ic">📅</span><span>Si lo pides hoy, te llegaría <b>'+r+'</b> <span style="opacity:.8">(estimado en días hábiles).</span></span>';
  }
  document.addEventListener('click',function(e){ if(e.target.closest('#ppShip .pp-shipbtn')) setTimeout(update,0); });
  window.addEventListener('hashchange',function(){ setTimeout(update,60); });
  if(document.readyState!=='loading') update(); else document.addEventListener('DOMContentLoaded',update);
  window.VELANTIS_ETA={update:update};
})();
;
/* index-28 */

/* ===== VELANTIS_HERO_PLAY — asegura que el video del hero se reproduzca ===== */
(function(){
  function play(){ var v=document.querySelector('.vh-video'); if(!v) return; v.muted=true;
    var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
  if(document.readyState!=='loading') play(); else document.addEventListener('DOMContentLoaded',play);
  window.addEventListener('hashchange',function(){ setTimeout(play,60); });
  document.addEventListener('visibilitychange',function(){ if(!document.hidden) play(); });
})();
;
/* index-29 */

/* ===== VELANTIS_ELEVA — página de combinaciones (layering) ===== */
(function(){
  var page=document.getElementById('elevaPage'); if(!page) return;
  var grid=document.getElementById('evGrid'), search=document.getElementById('evSearch'), moreBtn=document.getElementById('evMore');
  var elTitle=page.querySelector('.ev-title'), elSub=page.querySelector('.ev-sub');
  function CAT(){ return window.VELANTIS_CAT||[]; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function de(s){ return String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase(); }
  function hash(s){ var x=2166136261; for(var i=0;i<s.length;i++){ x^=s.charCodeAt(i); x=Math.imul(x,16777619); } return x>>>0; }
  function partner(r){ var c=CAT(), alt=null;
    for(var i=0;i<c.length;i++){ var s=c[i]; if(s[1]==='Ambiental'||s[0]===r[0]) continue;
      if(s[4]!==r[4] && s[1]===r[1]){ if(hash(r[0]+s[0])%7===0){ alt=s; break; } if(!alt) alt=s; } }
    return alt;
  }
  function mini(r){ var key=esc(r[9]||'amaderados');
    return '<div class="ev-mini"><div class="cat-img n-'+key+'"></div><span class="ev-name">'+(r[12]?'<b>'+esc(r[12])+'</b>':'')+esc(r[0])+'</span></div>'; }
  function tipText(r,p){ return p ? ('Aplica <b>'+esc(r[0])+'</b> en muñecas y cuello; remata con <b>'+esc(p[0])+'</b> para una estela más personal e inolvidable.')
                : ('Aplica <b>'+esc(r[0])+'</b> en muñecas y cuello y úsalo generoso para máxima proyección.'); }
  function addBtn(r,p){ return '<button class="ev-add" type="button" data-an="'+esc(r[0])+'" data-ap="'+(r[11]||590)+'" data-ai="n-'+esc(r[9]||'amaderados')+'" data-as="'+esc(r[3]||'')+'"'+
      (p?(' data-bn="'+esc(p[0])+'" data-bp="'+(p[11]||590)+'" data-bi="n-'+esc(p[9]||'amaderados')+'" data-bs="'+esc(p[3]||'')+'"'):'')+'>'+
      (p?'Agregar ambos al carrito':'Agregar al carrito')+'</button>'; }
  function card(r){ var p=partner(r);
    return '<article class="ev-card"><div class="ev-pair">'+mini(r)+'<span class="ev-plus">+</span>'+
      (p?mini(p):'<div class="ev-mini ev-solo">Brilla<br> solo</div>')+'</div><p class="ev-tip">'+tipText(r,p)+'</p>'+addBtn(r,p)+'</article>';
  }
  /* ---- vista DÚO por producto (#/eleva/<nombre>) ---- */
  function priceBig(r){ return (r[1]==='Ambiental')?('$'+(r[11]||449)+' MXN'):('$'+(r[11]||590)+' MXN'); }
  function findRow(id){ id=de(id); return CAT().find(function(r){ return de(r[0])===id || de(r[12]||'')===id; }); }
  function bigCard(r,tag){ var key=esc(r[9]||'amaderados');
    return '<div class="ev-big"><span class="ev-big-tag">'+esc(tag)+'</span><div class="ev-big-img cat-img n-'+key+'"></div>'+
      '<div class="ev-big-info">'+(r[12]?'<span class="ev-big-sku">'+esc(r[12])+'</span>':'')+'<h3>'+esc(r[0])+'</h3>'+
      '<p class="ev-big-fam">'+esc(r[3])+(r[2]?' · Inspirado en '+esc(r[2]):'')+'</p><div class="ev-big-price">'+priceBig(r)+'</div></div></div>'; }
  function setMode(duo){
    if(search) search.style.display=duo?'none':'';
    if(duo && moreBtn) moreBtn.hidden=true;
    grid.classList.toggle('ev-grid-duo', !!duo);
    if(!duo){ if(elTitle) elTitle.textContent='Layering'; if(elSub) elSub.textContent='Combina dos fragancias Velantis y crea una estela única, más personal e inolvidable. Estas son nuestras combinaciones recomendadas para cada aroma.'; }
  }
  function buildDuo(name){
    var r=findRow(name); if(!r){ setMode(false); build(); return; }
    var p=partner(r);
    if(elTitle) elTitle.textContent='Tu Layering';
    if(elSub) elSub.innerHTML='La combinación que eleva <b>'+esc(r[0])+'</b> a otro nivel.';
    setMode(true);
    grid.innerHTML='<div class="ev-duo">'+bigCard(r,'Tu perfume')+'<span class="ev-duo-plus">+</span>'+
      (p?bigCard(p,'Combínalo con'):'<div class="ev-big ev-solo-big"><span class="ev-big-tag">Perfecto solo</span></div>')+'</div>'+
      '<p class="ev-duo-tip">'+tipText(r,p)+'</p><div class="ev-duo-btn">'+addBtn(r,p)+'</div>'+
      '<a class="ev-duo-back" href="#/eleva">Ver todas las combinaciones →</a>';
  }
  var list=[], shown=0, PAGE=24, fSearch='';
  function build(){
    list=CAT().filter(function(r){ return r[1]!=='Ambiental'; });
    if(fSearch) list=list.filter(function(r){return VelantisBusqueda.coincidencia(fSearch,{sku:r[12],nombre:r[0],casa:r[2],texto:r.slice(0,9).join(' ')})>0;});
    shown=0; grid.innerHTML=''; renderMore();
  }
  function renderMore(){
    var slice=list.slice(shown, shown+PAGE), html='';
    slice.forEach(function(r){ html+=card(r); });
    grid.insertAdjacentHTML('beforeend', html);
    shown+=slice.length; moreBtn.hidden = shown>=list.length;
    if(!list.length) grid.innerHTML='<p class="ev-solo" style="grid-column:1/-1;padding:30px">Sin resultados · prueba otro nombre.</p>';
  }
  moreBtn.addEventListener('click', renderMore);
  // agregar ambos perfumes de la combinación al carrito
  grid.addEventListener('click', function(e){
    var b=e.target.closest('.ev-add'); if(!b) return;
    var cart=window.VelantisCart; if(!cart||!cart.add) return;
    cart.add({ name:b.getAttribute('data-an'), price:+b.getAttribute('data-ap')||499, img:b.getAttribute('data-ai')||'', sub:b.getAttribute('data-as')||'' });
    if(b.getAttribute('data-bn')) cart.add({ name:b.getAttribute('data-bn'), price:+b.getAttribute('data-bp')||499, img:b.getAttribute('data-bi')||'', sub:b.getAttribute('data-bs')||'' });
    var t=b.textContent; b.textContent='Agregados ✓'; setTimeout(function(){ b.textContent=t; },1500);
    if(cart.open) cart.open();
  });
  var _st; search.addEventListener('input', function(){ clearTimeout(_st); _st=setTimeout(function(){ fSearch=de(search.value.trim()); build(); }, 140); });
  function route(){
    var hs=(location.hash||''); if(hs.length>7 && hs.charAt(hs.length-1)==='/') hs=hs.slice(0,-1);
    var isEv=(hs.indexOf('#/eleva')===0);
    document.body.classList.toggle('eleva', isEv);
    page.hidden=!isEv;                       // vencer [hidden]!important
    if(!isEv) return;
    var focus = hs.length>('#/eleva'.length) ? decodeURIComponent(hs.slice(('#/eleva/').length)) : '';
    if(focus) buildDuo(focus); else { setMode(false); build(); }
    window.scrollTo(0,0);
  }
  window.addEventListener('hashchange', route);
  if(document.readyState!=='loading') route(); else document.addEventListener('DOMContentLoaded', route);
})();
;
/* index-30 */

/* ===== VELANTIS_RELAUNCH — promo de relanzamiento (tira + toast + carrito) ===== */
(function(){
  var DEST='#/best-sellers';
  function go(){ location.hash=DEST; if(window.VelantisCart&&window.VelantisCart.close) window.VelantisCart.close(); }
  // (1) tira clicable
  var strip=document.getElementById('promoStrip');
  if(strip){ strip.addEventListener('click',go);
    strip.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); go(); } }); }
  // (3) recordatorio del carrito: al tocar, cierra carrito y va a elegir
  var cr=document.getElementById('cartRelanz'); if(cr) cr.addEventListener('click',function(){ if(window.VelantisCart&&window.VelantisCart.close) window.VelantisCart.close(); });
  // (2) toast en producto
  var toast=document.getElementById('promoToast'), tX=document.getElementById('promoToastX');
  var tTimer=null, closedFor='';
  function showToast(){ if(!toast)return; clearTimeout(tTimer); toast.classList.add('show'); tTimer=setTimeout(hideToast,10000); }
  function hideToast(){ if(!toast)return; clearTimeout(tTimer); toast.classList.remove('show'); }
  if(tX) tX.addEventListener('click',function(){ closedFor=location.hash; hideToast(); });
  function onRoute(){
    var isProd=/^#\/p\//.test(location.hash||'');
    if(isProd){ if(closedFor!==location.hash){ setTimeout(showToast,650); } }
    else hideToast();
  }
  window.addEventListener('hashchange',onRoute);
  if(document.readyState!=='loading') onRoute(); else document.addEventListener('DOMContentLoaded',onRoute);
})();
;
/* index-31 */

/* ===== VELANTIS_GIFT — regalo 30 ml por cada 2 perfumes (dropdown propio + layering) ===== */
(function(){
  var box=document.getElementById('cartGift'), itemsEl=document.getElementById('cartItems');
  if(!box||!itemsEl) return;
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function stored(){ try{ return JSON.parse(localStorage.getItem('velantis_gifts')||'[]'); }catch(e){ return []; } }
  function saveSel(arr){ try{ localStorage.setItem('velantis_gifts', JSON.stringify(arr)); }catch(e){} }
  function CAT(){ return window.VELANTIS_CAT||[]; }
  // Layering recomendado — MISMA lógica que la página individual (#/eleva): FNV-1a + grupo r[4]
  // distinto, mismo género r[1], primer candidato con hash%7===0 (o el primero disponible).
  function ghash(s){ var x=2166136261; for(var i=0;i<s.length;i++){ x^=s.charCodeAt(i); x=Math.imul(x,16777619); } return x>>>0; }
  function partnerOf(name){
    var c=CAT(), r=null; for(var i=0;i<c.length;i++){ if(c[i][0]===name){ r=c[i]; break; } }
    if(!r) return null;
    var alt=null;
    for(var i=0;i<c.length;i++){ var s=c[i];
      if(s[1]==='Ambiental'||s[0]===r[0]) continue;
      if(s[4]!==r[4] && s[1]===r[1]){ if(ghash(r[0]+s[0])%7===0){ alt=s; break; } if(!alt) alt=s; }
    }
    return alt?alt[0]:null;
  }
  function opt(val,label,extraCls){ return '<div class="cg-dd-opt'+(extraCls?' '+extraCls:'')+'" data-val="'+esc(val)+'">'+esc(label)+'</div>'; }
  function build(){
    var names=[], units=0;
    [].forEach.call(itemsEl.querySelectorAll('.ci'), function(ci){
      var nm=ci.querySelector('.ci-name'), q=ci.querySelector('.ci-qty span');
      if(!nm) return;
      var sub=(ci.querySelector('.ci-sub')||{}).textContent||'';
      // solo PERFUMES cuentan (excluir difusores, aceites, ambientales y regalos)
      if(/difusor|aceite|aroma de ambiente|regalo/i.test(sub)) return;
      var qty=q?(parseInt(q.textContent,10)||1):1;
      names.push(nm.textContent.trim()); units+=qty;
    });
    /* Con tope. Sin el, un carrito con una cantidad disparatada armaba
       cientos de desplegables y la pestana dejaba de responder. */
    var gifts=Math.min(10, Math.floor(units/2));
    if(!gifts || !names.length){ box.hidden=true; box.innerHTML=''; return; }
    box.hidden=false;
    var sel=stored();
    var html='<div class="cg-head"><span class="cg-badge">🎁 Regalo de tu promoción de relanzamiento</span>'+
      '<span class="cg-sub">Por cada 2 perfumes, un perfume de bolso 30&nbsp;ml GRATIS · elige el aroma o su Layering</span></div>';
    for(var i=0;i<gifts;i++){
      var a=names[i*2], b=names[i*2+1]||names[i*2];
      var pair=(a===b)?[a]:[a,b];
      // opciones: aromas del par + layering recomendado de cada uno
      var opts=pair.map(function(n){ return opt(n,n); }).join('');
      var lay='';
      pair.forEach(function(n){ var p=partnerOf(n); if(p) lay+=opt('LAY::'+n+'::'+p, '✦ Layering: '+n+' + '+p, 'cg-dd-lay'); });
      if(lay) opts+='<div class="cg-dd-sep"></div>'+lay;
      // etiqueta actual
      var cur=sel[i]||pair[0], label=cur;
      if(String(cur).indexOf('LAY::')===0){ var pp=cur.split('::'); label='✦ '+pp[1]+' + '+pp[2]; }
      else if(pair.indexOf(cur)<0){ cur=pair[0]; label=cur; }
      html+='<div class="cg-item"><div class="cg-info"><span class="cg-title">Perfume de bolso · 30&nbsp;ml</span>'+
        '<span class="cg-choose-l">Elige tu aroma</span>'+
        '<div class="cg-dd" data-i="'+i+'" data-val="'+esc(cur)+'">'+
          '<button class="cg-dd-trigger" type="button"><span class="cg-dd-lbl">'+esc(label)+'</span>'+
            '<svg class="cg-dd-cae" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg></button>'+
          '<div class="cg-dd-panel">'+opts+'</div>'+
        '</div></div><span class="cg-free">GRATIS</span></div>';
    }
    box.innerHTML=html;
    // guardar selección actual por defecto
    var cur2=[]; [].forEach.call(box.querySelectorAll('.cg-dd'),function(d){ cur2.push(d.getAttribute('data-val')); });
    saveSel(cur2);
  }
  // interacción del dropdown
  box.addEventListener('click',function(e){
    var trg=e.target.closest('.cg-dd-trigger');
    if(trg){ var dd=trg.closest('.cg-dd'); var wasOpen=dd.classList.contains('open');
      [].forEach.call(box.querySelectorAll('.cg-dd.open'),function(x){x.classList.remove('open');});
      if(!wasOpen) dd.classList.add('open'); e.stopPropagation(); return; }
    var o=e.target.closest('.cg-dd-opt');
    if(o){ var dd2=o.closest('.cg-dd'); var val=o.getAttribute('data-val');
      var label=o.textContent.trim();
      dd2.setAttribute('data-val',val); dd2.querySelector('.cg-dd-lbl').textContent=label;
      dd2.classList.remove('open');
      var arr=[]; [].forEach.call(box.querySelectorAll('.cg-dd'),function(x){ arr.push(x.getAttribute('data-val')); });
      saveSel(arr); return; }
  });
  document.addEventListener('click',function(e){ if(!e.target.closest('#cartGift .cg-dd')) [].forEach.call(box.querySelectorAll('.cg-dd.open'),function(x){x.classList.remove('open');}); });
  new MutationObserver(build).observe(itemsEl, {childList:true, subtree:true});
  build();
})();
;
/* index-32 */

/* ===== VELANTIS_CC — páginas Aceites / Difusores ===== */
(function(){
  function route(){
    var hs=location.hash||'';
    var isA=/^#\/aceites\/?$/.test(hs), isD=/^#\/difusores\/?$/.test(hs);
    document.body.classList.toggle('aceites',isA);
    document.body.classList.toggle('difusores',isD);
    var a=document.getElementById('aceitesPage'); if(a)a.hidden=!isA;
    var d=document.getElementById('difusoresPage'); if(d)d.hidden=!isD;
    if(isA||isD) window.scrollTo(0,0);
  }
  window.addEventListener('hashchange',route);
  if(document.readyState!=='loading') route(); else document.addEventListener('DOMContentLoaded',route);
})();
;
/* index-33 */

/* ===== VELANTIS_DROP20 — preventa se libera el día 20 de cada mes ===== */
(function(){
  var MESES=['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  var el=document.getElementById('preDrop'); if(!el) return;
  function cap(s){ return s.charAt(0).toUpperCase()+s.slice(1); }
  function mesNombre(m){ return MESES[((m%12)+12)%12]; }
  // Todas las preventas son del MES SIGUIENTE y se liberan el día 20.
  function state(){
    var now=new Date();
    var d=now.getDate(), m=now.getMonth(), y=now.getFullYear();
    var openPv, dropM, dropY;
    if(d>=20){
      // ya se liberó la preventa del mes siguiente; el próximo drop es el 20 del mes que viene (mes+2)
      openPv=m+1; dropM=m+1; dropY=y;
    }else{
      // vigente la preventa de este mes (liberada el 20 anterior); el próximo drop es el 20 de este mes (mes+1)
      openPv=m; dropM=m; dropY=y;
    }
    return {
      openMes: mesNombre(openPv),        // preventa actualmente abierta (mes siguiente al de su liberación)
      nextMes: mesNombre(openPv+1),      // la que se liberará en el próximo día 20
      dropMes: mesNombre(dropM),         // mes del próximo día 20
      target: new Date(dropY, dropM, 20, 0, 0, 0),
      dropToday: (d===20)
    };
  }
  function two(n){ return (n<10?'0':'')+n; }
  function render(){
    var s=state();
    var diff=Math.max(0, s.target-new Date());
    var dd=Math.floor(diff/86400000), hh=Math.floor(diff%86400000/3600000), mm=Math.floor(diff%3600000/60000), ss=Math.floor(diff%60000/1000);
    var cd='<div class="pre-cd">'+
        '<div class="pre-cd-unit"><div class="pre-cd-n">'+two(dd)+'</div><div class="pre-cd-l">días</div></div>'+
        '<div class="pre-cd-unit"><div class="pre-cd-n">'+two(hh)+'</div><div class="pre-cd-l">hrs</div></div>'+
        '<div class="pre-cd-unit"><div class="pre-cd-n">'+two(mm)+'</div><div class="pre-cd-l">min</div></div>'+
        '<div class="pre-cd-unit"><div class="pre-cd-n">'+two(ss)+'</div><div class="pre-cd-l">seg</div></div>'+
      '</div>';
    el.hidden=false; el.classList.add('open');
    if(s.dropToday){
      el.innerHTML='<div class="pre-drop-ic">🎉</div>'+
        '<div class="pre-drop-main"><span class="pre-drop-badge">Liberada hoy</span>'+
        '<p class="pre-drop-txt"><b>Preventa de '+cap(s.openMes)+' liberada hoy.</b> Reserva los lanzamientos del mes siguiente antes de su llegada oficial.</p>'+
        '<p class="pre-drop-sub">Cada día 20 liberamos la preventa del mes siguiente.</p></div>'+cd;
    }else{
      el.innerHTML='<div class="pre-drop-ic">🔓</div>'+
        '<div class="pre-drop-main"><span class="pre-drop-badge">Preventa abierta</span>'+
        '<p class="pre-drop-txt"><b>Preventa de '+cap(s.openMes)+' abierta.</b> Reserva los lanzamientos del mes siguiente antes de su llegada oficial.</p>'+
        '<p class="pre-drop-sub">Próxima preventa (de '+cap(s.nextMes)+') el 20 de '+s.dropMes+'.</p></div>'+cd;
    }
  }
  render(); setInterval(render, 1000);
})();
;
/* index-34 */

/* ===== VELANTIS_PRIVE — página del club Privé ===== */
(function(){
  function route(){
    var isP=/^#\/prive\/?$/.test(location.hash||'');
    document.body.classList.toggle('prive',isP);
    var p=document.getElementById('privePage'); if(p)p.hidden=!isP;
    if(isP) window.scrollTo(0,0);
  }
  window.addEventListener('hashchange',route);
  if(document.readyState!=='loading') route(); else document.addEventListener('DOMContentLoaded',route);
})();
;
/* index-35 */

/* ===== VELANTIS_ACCOUNT — historial, búsquedas, recomendados, lanzamientos ===== */
(function(){
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function CAT(){return window.VELANTIS_CAT||[];}
  function findByName(n){return CAT().filter(function(r){return r[0]===n;})[0]||null;}
  function get(k){try{return JSON.parse(localStorage.getItem(k)||'[]');}catch(e){return [];}}
  function set(k,v){try{localStorage.setItem(k,JSON.stringify(v.slice(0,12)));}catch(e){}}
  function pushUniq(k,val){ if(!val)return; var a=get(k).filter(function(x){return x!==val;}); a.unshift(val); set(k,a); }

  // ----- tracking -----
  window.addEventListener('hashchange',function(){
    var m=(location.hash||'').match(/^#\/p\/(.+)$/);
    if(m){ try{ pushUniq('velantis_hist', decodeURIComponent(m[1])); }catch(e){} }
  });
  var _t;
  document.addEventListener('input',function(e){
    var id=e.target && e.target.id;
    if(['gsInput','xfSearch','catSearch','evSearch'].indexOf(id)<0) return;
    clearTimeout(_t); var v=(e.target.value||'').trim();
    _t=setTimeout(function(){ if(v.length>=2) pushUniq('velantis_search', v); }, 900);
  });

  // ----- render dentro del panel -----
  function openProd(name){ location.hash='#/p/'+encodeURIComponent(name); var ov=document.getElementById('acOv'); if(ov)ov.classList.remove('show'); document.body.style.overflow=''; }
  function histRow(r){
    return '<div class="ac-hist-i" data-open="'+esc(r[0])+'">'+
      '<div class="ac-hist-img n-'+esc(r[9])+'"></div>'+
      '<div class="ac-hist-x"><div class="ac-hist-code">'+esc(r[12]||'')+'</div>'+
        '<div class="ac-hist-nm">'+esc(r[0])+'</div>'+
        '<div class="ac-hist-h">'+(r[2]?'Inspirado en · '+esc(r[2]):'')+'</div></div></div>';
  }
  function recommend(hist){
    var cat=CAT(); if(!cat.length) return [];
    var fam=null; for(var i=0;i<hist.length;i++){ var r=findByName(hist[i]); if(r){fam=r[3];break;} }
    if(!fam) return [];
    var seen={}; hist.forEach(function(n){seen[n]=1;});
    return cat.filter(function(r){return r[3]===fam && !seen[r[0]] && r[1]!=='Ambiental';}).slice(0,3);
  }
  function render(){
    var box=document.getElementById('acDyn'); if(!box) return;
    var hist=get('velantis_hist'), searches=get('velantis_search');
    var histRows=hist.map(findByName).filter(Boolean).slice(0,4);
    var recs=recommend(hist);
    var html='';
    // PRIVÉ
    html+='<a class="ac-prive" href="#/prive" data-prive><span class="ac-prive-ic">✦</span>'+
      '<span><b>Velantis Privé</b><span>Únete al círculo privado por WhatsApp</span></span></a>';
    // historial
    if(histRows.length){
      html+='<div class="ac-sec"><div class="ac-sec-h">Visto recientemente</div><div class="ac-hist">'+
        histRows.map(histRow).join('')+'</div></div>';
    }
    // recomendados
    if(recs.length){
      html+='<div class="ac-sec"><div class="ac-sec-h">Recomendados para ti</div><div class="ac-hist">'+
        recs.map(histRow).join('')+'</div></div>';
    }
    // aromas buscados
    if(searches.length){
      html+='<div class="ac-sec"><div class="ac-sec-h">Aromas que buscaste</div><div class="ac-chips">'+
        searches.slice(0,8).map(function(q){return '<span class="ac-chip" data-q="'+esc(q)+'">'+esc(q)+'</span>';}).join('')+'</div></div>';
    }
    // 4-sep: la seccion «Nuevos lanzamientos» (Novedades 2026 + Preventa del mes) se retiro del panel Mi cuenta a peticion de la casa.
    box.innerHTML=html;
  }

  // interacciones dentro del panel
  document.addEventListener('click',function(e){
    var hi=e.target.closest && e.target.closest('.ac-hist-i'); if(hi){ openProd(hi.getAttribute('data-open')); return; }
    var ch=e.target.closest && e.target.closest('.ac-chip'); if(ch){ var q=ch.getAttribute('data-q');
      var gs=document.getElementById('gsInput'); if(gs){ var ov=document.getElementById('acOv'); if(ov)ov.classList.remove('show');
        var so=document.getElementById('gsOv'); if(so){so.classList.add('show'); document.body.style.overflow='hidden';}
        gs.value=q; gs.dispatchEvent(new Event('input',{bubbles:true})); gs.focus(); } return; }
    var pv=e.target.closest && e.target.closest('[data-prive]'); if(pv){ var ov2=document.getElementById('acOv'); if(ov2)ov2.classList.remove('show'); document.body.style.overflow=''; }
  });

  // re-render al abrir el panel (icono perfil) y al cargar
  var perfil=document.querySelector('.tools .icon-btn[aria-label="Mi perfil"]');
  if(perfil) perfil.addEventListener('click',function(){ setTimeout(render,30); });
  if(document.readyState!=='loading') render(); else document.addEventListener('DOMContentLoaded',render);
})();
;
/* index-36 */


/* ===== VELANTIS_ACEITES ===== */

(function(){

  var CATS=[["Hoteles",["Vidanta","Vidanta Luxxe","Atelier","Wynn","Aria","MGM","Hard Rock","Bvlgari Tokyo","Royal Champagne","Xcaret","Xcaret Parque"]],["Tiendas",["Innova Sport","Palacio","Zara Home","Muy Mucho","Mahogany Teakwood","Emwa","Lincoln","Abercrombie","Palacio de Hierro","Emwa Joyería"]],["Perfume",["Santal","Bergamote 22","Baccarat","Lime Basil & Mandarin","Aventus","Tobacco Vanille","Erba Pura","Layton","Frenesí","Organs","The Noir 29","Santal 33","Baccarat Rouge 540","Invictus","A&F Fierce","Absolut Leather"]],["Otros",["Car New","Leather","Té Negro Le Labo","Maderas del Mediterráneo","Lino y Aloe","Ámbar Cedro","Japanese Lotus","White Tea","Lino & Aloe"]]], SIZES=[["100 ml",450],["250 ml",900],["1 L",2200]], PYR={"Vidanta":["bergamota, limón","jazmín, flores blancas","maderas blancas, almizcle"],"Vidanta Luxxe":["cítricos, mandarina","flor de azahar, jazmín","ámbar, sándalo"],"Atelier":["lavanda, bergamota","salvia, geranio","cedro, vetiver"],"Wynn":["bergamota, limón","té verde, jazmín","maderas, almizcle"],"Aria":["cítricos, pomelo","flores blancas, jazmín","almizcle, maderas"],"MGM":["cítricos, pimienta rosa","especias, flores","maderas, ámbar"],"Hard Rock":["pimienta, cítricos","cuero, tabaco","maderas, especias"],"Bvlgari Tokyo":["yuzu, bergamota","té verde, bambú, jazmín","madera, almizcle"],"Royal Champagne":["uva, cítricos","flores blancas, durazno","almizcle, maderas"],"Xcaret":["cítricos, coco","flores tropicales, jazmín","madera, almizcle"],"Xcaret Parque":["cítricos, brisa marina","coco, flores","ámbar, maderas"],"Innova Sport":["cítricos, menta","lavanda, especias","maderas, almizcle"],"Palacio":["bergamota, cítricos","flores, especias","cuero, madera"],"Zara Home":["flor de algodón, cítricos","jazmín, flores blancas","ámbar, vainilla, almizcle"],"Muy Mucho":["frutas, cítricos","flores, durazno","vainilla, almizcle"],"Mahogany Teakwood":["bergamota, especias","caoba, teca","cuero, cedro"],"Emwa":["cítricos, pera","flores blancas, jazmín","almizcle, maderas suaves"],"Lincoln":["cítricos, cardamomo","cedro dulce, flores","ámbar, vainilla, maderas"],"Abercrombie":["cítricos, cardamomo","petitgrain, flores","cuero, almizcle, maderas"],"Santal":["cardamomo, cítricos","iris, violeta, cuero","sándalo, papiro, ámbar"],"Bergamote 22":["bergamota, pomelo","petitgrain, jengibre","almizcle, ámbar, incienso"],"Baccarat":["azafrán, jazmín","ámbar gris, madera","cedro, resinas"],"Lime Basil & Mandarin":["lima, mandarina, bergamota","albahaca, jazmín","ámbar, vetiver, pachulí"],"Aventus":["piña, bergamota, manzana","abedul, pachulí, rosa","almizcle, roble, ámbar gris"],"Tobacco Vanille":["tabaco, especias","vainilla, cacao, fruta seca","frutos secos, tonka, madera"],"Erba Pura":["cítricos, frutas dulces","frutas maduras, flores","ámbar, vainilla, almizcle"],"Layton":["manzana, bergamota, mandarina","lavanda, geranio, violeta","vainilla, sándalo, cardamomo"],"Frenesí":["frutos rojos, cítricos","flores blancas, jazmín","vainilla, almizcle"],"Organs":["bergamota, cítricos","flores, especias","maderas, ámbar"],"The Noir 29":["bergamota, higo, laurel","té negro, tabaco","maderas, vetiver, musgo"],"Car New":["cítricos, aldehídos","cuero nuevo, flores","maderas, almizcle"],"Leather":["azafrán, cítricos","cuero, tabaco","ámbar, maderas"],"Té Negro Le Labo":["bergamota, higo, laurel","té negro, tabaco","maderas, vetiver"],"Maderas del Mediterráneo":["cítricos, romero","ciprés, lavanda","cedro, maderas"],"Lino y Aloe":["lino fresco, cítricos","aloe, flores blancas","almizcle, maderas suaves"],"Ámbar Cedro":["cítricos, especias","cedro, incienso","ámbar, vainilla, almizcle"],"Japanese Lotus":["flor de loto, cítricos","té verde, bambú","almizcle, maderas"],"White Tea":["té blanco, cítricos","flores blancas, jazmín","almizcle, maderas suaves"],"Santal 33":["cardamomo, cítricos","iris, violeta, cuero","sándalo, papiro, ámbar"],"Baccarat Rouge 540":["azafrán, jazmín","ámbar gris, madera","cedro, resinas"],"Absolut Leather":["azafrán, cítricos","cuero, tabaco","ámbar, maderas"],"Palacio de Hierro":["bergamota, cítricos","flores blancas, jazmín","ámbar, maderas nobles"],"Emwa Joyería":["cítricos, pera","flores blancas, jazmín","almizcle, maderas suaves"],"Lino & Aloe":["lino fresco, cítricos","aloe, flores blancas","almizcle, maderas suaves"],"Invictus":["notas marinas, toronja (pomelo), mandarina","hoja de laurel, jazmín","ámbar gris, madera de gaiac, musgo de roble, pachulí"],"A&F Fierce":["abeto, limón (lima ácida), naranja, notas marinas, petit grain, cardamomo","romero, lirio de los valles (muguete), jazmín, salvia, rosa","almizcle, vetiver, musgo de roble, palo de rosa de brasil, sándalo"]};

  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}

  function cap(s){return String(s||'').replace(/^\s*([a-záéíóúñ])/,function(m,c){return c.toUpperCase();});}

  window.VELANTIS_LHS=window.VELANTIS_LHS||{};

  CATS.forEach(function(g){ g[1].forEach(function(n){

    var p=PYR[n]||['','',''], nt=p.filter(Boolean).join(', ');

    window.VELANTIS_LHS[n]={ name:n, kind:'aceite', eyebrow:g[0]+' · Aceite', img:'oil-ph', sizes:SIZES, notes:nt, pyr:p,

      desc:'Aceite aromático de alta concentración para difusor y espacios.',

      long:'Aceite aromático '+n+' de alta concentración'+(nt?', con notas de '+nt:'')+'. Perfuma tu hogar, tu auto y cualquier espacio con una estela envolvente y de larga duración. Compatible con el difusor Velantis y de uso general. Disponible en 100 ml, 250 ml, 500 ml y 1 litro.' };

  });});

  function card(name,cat){

    var p=PYR[name]||['','',''], nt=p.filter(Boolean).join(', ');

    return '<article class="oil-card" data-lhs="'+esc(name)+'" data-name="'+esc(name)+' · Aceite 100 ml" data-price="450" data-img="oil-ph" data-sub="Aceite para difusor · 100 ml" tabindex="0">'+

      '<div class="oil-img oil-ph"></div>'+

      '<div class="oil-body"><div class="oil-cat">'+esc(cat)+'</div><h3>'+esc(name)+'</h3>'+

      '<p class="oil-desc">Aceite para difusor</p>'+

      (nt?'<p class="oil-notes">'+esc(cap(nt))+'</p>':'')+

      '<div class="oil-price">desde $450 <small>MXN</small></div>'+

      '<button class="add" type="button">Agregar al carrito</button></div></article>';

  }

  function giftMode(){ try{return localStorage.getItem('velantis_oilgift')==='1';}catch(e){return false;} }

  function updateBanner(){ var b=document.getElementById('oilGiftBanner'); if(b) b.hidden=!(giftMode() && /^#\/aceites\/?$/.test(location.hash||'')); }

  function render(){

    var box=document.getElementById('aceitesCatalog'); if(!box) return;

    box.innerHTML='<div class="oil-giftbanner" id="oilGiftBanner" hidden>🎁 Estás eligiendo tu <b>aceite de regalo</b> — toca cualquier aceite y se agrega <b>100&nbsp;ml GRATIS</b> por tu difusor.</div>'+

      CATS.map(function(g){

        return '<div class="oil-group"><div class="oil-group-s">Colección</div><h3 class="oil-group-h">'+esc(g[0])+'</h3>'+

          '<div class="oil-grid">'+g[1].map(function(n){return card(n,g[0]);}).join('')+'</div></div>';

      }).join('');

    if(!box._wired){ box._wired=1;

      box.addEventListener('click',function(e){

        var addBtn=e.target.closest('.add');

        if(addBtn){

          if(giftMode()){

            e.preventDefault(); e.stopImmediatePropagation();

            var c0=addBtn.closest('.oil-card'), nm=((c0.querySelector('h3')||{}).textContent||'').trim();

            if(window.VelantisCart) window.VelantisCart.add({name:nm+' · Aceite 100 ml (Regalo)', price:0, img:'oil-ph', sub:'Aceite de regalo · 100 ml · por tu difusor'});

            try{localStorage.removeItem('velantis_oilgift');}catch(x){}

            updateBanner();

            if(window.VelantisCart&&window.VelantisCart.open) window.VelantisCart.open();

          }

          return;

        }

        var c=e.target.closest('.oil-card'); if(!c) return;

        location.hash='#/lhs/'+encodeURIComponent(c.getAttribute('data-lhs'));

      });

    }

    updateBanner();

    var grid=document.getElementById('aceitesGrid'); if(grid) grid.hidden=true;

    var soon=document.getElementById('aceitesSoon'); if(soon) soon.style.display='none';

  }

  window.addEventListener('hashchange',updateBanner);

  if(document.readyState!=='loading') render(); else document.addEventListener('DOMContentLoaded',render);

})();

;
/* index-37 */


/* ===== VELANTIS_DIFUSORES ===== */

(function(){

  var DIFS=[["Velantis Diffuser","velantis","//velantis.mx/cdn/shop/t/44/assets/dif-velantis.jpg?v=116630435302819638991791836361",1499,"Nuestro difusor insignia: nebulización en frío con control por Bluetooth desde tu celular.",["Cobertura: hasta 1000 m³ de aroma","Capacidad: hasta 400 ml por tanque","Conectividad Bluetooth · App Control","Aroma incluido"],"El corazón de la experiencia Velantis. Nuestro difusor insignia transforma cualquier ambiente en una firma olfativa memorable: nebuliza el aroma en frío —sin agua ni calor— para conservar cada matiz de la fragancia intacto y difundirlo de forma uniforme por hasta 1000 m³. Con tanque de 400 ml y control total por Bluetooth desde tu celular, programas intensidad y horarios a tu gusto y dejas que tu esencia reciba a quien llega. Incluye un aroma a elegir del catálogo. Elegancia que se siente antes de verse.","Ideal para hogares amplios, oficinas, recepciones y comercios de tamaño medio."],["Scent Diffuser 3000","scent3000","//velantis.mx/cdn/shop/t/44/assets/dif-scent3000.jpg?v=66504491882622663841791836360",6900,"Difusor profesional de grado comercial y gran cobertura.",["Cobertura: 2000 m³ / 660 m²","Capacidad: 800 ml","Medida: 25 × 14 × 28.5 cm","App Control · Programable"],"Pensado para espacios que dejan huella. El Scent Diffuser 3000 es un equipo de grado comercial que envuelve grandes superficies —hasta 2000 m³— con una difusión constante, silenciosa y perfectamente uniforme. Su tanque de 800 ml y su programación por intervalos mantienen el aroma vivo todo el día sin que tengas que pensar en ello, y su control desde el celular te da el mando completo. La herramienta ideal para convertir tu marca en una experiencia que se recuerda.","Para áreas de oficinas, salas de espera, mostradores de venta, recepciones grandes, restaurantes, comercios y tiendas departamentales."],["Vertical Smart Diffuser","vertical","//velantis.mx/cdn/shop/t/44/assets/dif-vertical.jpg?v=127193905438257381451791836362",7500,"Difusor inteligente vertical de máxima cobertura y diseño esbelto.",["Cobertura: 3000 m³ / 1304 m²","Capacidad: 800 ml","Medida: 18.5 (base) × 60.6 cm","Panel digital · App Control"],"Presencia y potencia en una sola pieza. De diseño vertical esbelto y elegante, el Vertical Smart Diffuser alcanza la mayor cobertura de la línea —hasta 3000 m³— con una nebulización fina que llena estancias amplias sin esfuerzo. Ajusta intensidad e intervalos desde su panel digital o tu celular y crea atmósferas a la medida de cada momento. Un objeto de diseño que perfuma como un profesional y luce como una escultura.","Para departamentos, grandes salas o estancias, pisos corporativos y tiendas departamentales."],["Scent Diffuser 300","scent300","//velantis.mx/cdn/shop/t/44/assets/dif-scent300.jpg?v=95326202483395018111791836359",3500,"Difusor de cobertura media con control por app.",["Cobertura: 300 m³ / 160 m²","Capacidad: 200 ml","Medida: 8.6 × 16 × 20.5 cm","App Control · Recargable"],"El equilibrio perfecto entre potencia y discreción. El Scent Diffuser 300 cubre hasta 300 m³ con una difusión pareja y constante, ideal para dar carácter a espacios medianos sin robar protagonismo. Programa por intervalos, controla desde tu celular y disfruta de un aroma que acompaña sin saturar. Diseño sobrio, resultado impecable.","Para oficinas, tiendas de plazas comerciales, restaurantes, residencias medianas y lobbies."],["M22 Diffuser","m22","//velantis.mx/cdn/shop/t/44/assets/dif-m22.jpg?v=84987317901048243141791836358",1500,"Difusor compacto inteligente, potente y discreto.",["Cobertura: 100 m³ / 30 m²","Capacidad: 10 ml","Medida: 7 (base) × 13.7 cm","Recargable · Programable"],"Compacto por fuera, poderoso por dentro. El M22 lleva tu aroma favorito a tu escritorio, tu consultorio o tu rincón favorito con un diseño minimalista que combina con todo. Recargable y programable por intervalos, favorece la concentración y crea ambientes que invitan a quedarse. Pequeños detalles que hacen grande cada espacio.","Ideal para oficinas pequeñas, consultorios, salas de espera, recámaras y baños."],["Aroma Diffuser","aroma","//velantis.mx/cdn/shop/t/44/assets/dif-aroma.jpg?v=122512174173770678511791836357",3900,"Difusor de diseño elegante con panel de control digital.",["Cobertura: 300 m³ / 100 m²","Capacidad: 120 ml","Medida: 11.75 (base) × 34.2 cm","Panel digital · App Control"],"Diseño que se disfruta con todos los sentidos. De silueta esbelta y panel de control digital, el Aroma Diffuser difunde tu fragancia de forma silenciosa y constante por hasta 300 m³, creando ambientes acogedores en casa u oficina. Contrólalo desde su pantalla o tu celular y deja que cada rincón cuente tu historia olfativa. Elegancia funcional, aroma memorable.","Ideal para oficinas, recepciones, salas, cocinas y salones pequeños."],["Portable Plug-in Diffuser","portable","//velantis.mx/cdn/shop/t/44/assets/dif-portable.jpg?v=112203323630743435101791836359",1500,"Difusor de enchufe discreto con sensor y aro de luz.",["Cobertura: 100 m³ / 30 m²","Capacidad: 100 ml","Medida: 7.25 × 20.5 cm","Sensor y aro de luz · App Control"],"Aroma inteligente que se enciende solo. El Portable Plug-in se conecta directo a cualquier enchufe y, con su sensor y aro de luz, ilumina y perfuma de forma discreta baños, recámaras y espacios pequeños. Contrólalo desde tu celular y olvídate del resto: él se encarga de que cada rincón huela impecable. Diseño mínimo, presencia máxima.","Ideal para baños, recámaras, salas de estar, estudios, oficinas y espacios pequeños."]], AROMAS=[["Luxury Fragrances",["Santal 33","Baccarat Rouge 540","Invictus","Absolut Leather","A&F Fierce","Bergamote 22","Lime Basil & Mandarin"]],["Luxury Hotels",["Ritz Carlton","Fairmont","Westin","Live Aqua","Aria","Xcaret","Wynn","Atelier","Hard Rock","Vidanta"]],["Luxury Stores",["Muy Mucho","Palacio de Hierro","Zara Home","Innova Sport","Emwa Joyería","Bath & Body Works","Mahogany Teakwood"]],["Luxury Scents",["Palo Santo","Green Tea Bergamot","Té Negro Le Labo","Lino & Aloe","Lincoln","Flor de Loto","Sweet Cedarwood","Japanese Lotus","Té Blanco","Premium Cedar","Playita","Ámbar Cedro","Green Tea","Amber Dark","Eucalyptus","Maderas del Mediterráneo"]]], SIZES=[["100 ml",450],["250 ml",900],["1 L",2200]];

  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}

  function money(n){return '$'+Number(n).toLocaleString('es-MX');}

  window.VELANTIS_LHS=window.VELANTIS_LHS||{};

  DIFS.forEach(function(d){

    window.VELANTIS_LHS[d[0]]={ name:d[0], kind:'difusor', eyebrow:'Difusor', img:'dif-img-'+d[1], price:d[3],

      specs:d[5], desc:d[4], long:d[6], areas:d[7] };

  });

  AROMAS.forEach(function(g){ g[1].forEach(function(n){

    if(!window.VELANTIS_LHS[n]) window.VELANTIS_LHS[n]={ name:n, kind:'aroma', eyebrow:g[0]+' · Aroma', img:'oil-ph', sizes:SIZES,

      desc:'Aroma '+n+' para tu difusor Velantis. Disponible también como aceite de recarga.',

      long:'Aroma '+n+' ('+g[0]+') para el difusor Velantis y espacios. Fragancia envolvente y de larga duración, disponible como aroma incluido con tu difusor o como aceite de recarga en 100 ml, 250 ml, 500 ml y 1 litro.' };

  });});


  window.addEventListener('velantis:nombres',function(){
    document.querySelectorAll('#difusoresCatalog .dif-card').forEach(function(c){var h=c.querySelector('h3');if(h)h.textContent=window.VelantisNombres.nombre(c.dataset.name);});
  });

  function difCard(d){

    return '<article class="dif-card" data-lhs="'+esc(d[0])+'" data-name="'+esc(d[0])+'" data-price="'+d[3]+'" data-img="dif-img-'+d[1]+'" data-sub="Difusor" tabindex="0">'+

      '<div class="dif-card-img dif-img-'+d[1]+'"></div>'+

      '<div class="dif-card-body"><span class="dif-card-badge">Difusor</span><h3>'+esc(window.VelantisNombres?window.VelantisNombres.nombre(d[0]):d[0])+'</h3>'+

      '<p class="dif-card-desc">'+esc(d[4])+'</p>'+

      '<div class="dif-card-price">'+money(d[3])+' <small>MXN</small></div>'+

      '<button class="add" type="button">Agregar al carrito</button></div></article>';

  }

  function render(){

    var box=document.getElementById('difusoresCatalog'); if(!box) return;

    var ordenados=DIFS.slice().sort(function(a,b){return a[3]-b[3];});  // de barato a caro

    var difs='<div class="dif-seclbl">Modelos de difusor</div><div class="dif-grid">'+ordenados.map(difCard).join('')+'</div>';

    var aromas='<div class="dif-arolbl">Aromas disponibles</div>'+

      '<p class="dif-arosub">Toca un aroma para ver su ficha. Todos disponibles como aroma incluido y como aceite de recarga.</p>'+

      AROMAS.map(function(g){

        return '<div class="dif-group"><h3 class="dif-group-h">'+esc(g[0])+'</h3><div class="dif-chips">'+

          g[1].map(function(n){return '<span class="dif-chip" data-lhs="'+esc(n)+'">'+esc(n)+'</span>';}).join('')+'</div></div>';

      }).join('');

    box.innerHTML=difs+aromas;

    box.addEventListener('click',function(e){

      if(e.target.closest('.add')) return;

      var el=e.target.closest('[data-lhs]'); if(!el) return;

      location.hash='#/lhs/'+encodeURIComponent(el.getAttribute('data-lhs'));

    });

    var grid=document.getElementById('difusoresGrid'); if(grid) grid.hidden=true;

    var soon=document.getElementById('difusoresSoon'); if(soon) soon.style.display='none';

  }

  if(document.readyState!=='loading') render(); else document.addEventListener('DOMContentLoaded',render);

})();

;
/* index-38 */

/* ===== VELANTIS_LHS_PAGE — ficha de producto de aceites/difusores ===== */
(function(){
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function money(n){return '$'+Number(n).toLocaleString('es-MX');}
  var page=document.getElementById('lhsPage');
  var sel={ price:0, ml:'', base:'', img:'oil-ph', kind:'' };
  function reg(){ return window.VELANTIS_LHS||{}; }

  function render(name){
    var p=reg()[name];
    if(!p){ setTimeout(function(){ if(reg()[name]) render(name); else { document.body.classList.remove('lhs'); if(page)page.hidden=true; } },80); return; }
    sel.base=p.name; sel.img=p.img||'oil-ph'; sel.kind=p.kind;
    document.getElementById('lhsBack').setAttribute('href', p.kind==='ambiental' ? '#/ambientales' : (p.kind==='difusor'||p.kind==='aroma' ? '#/difusores' : '#/aceites'));
    document.getElementById('lhsImg').className='lhs-img '+(p.img||'oil-ph');
    document.getElementById('lhsEyebrow').textContent=p.eyebrow||'';
    document.getElementById('lhsName').textContent=window.VelantisNombres?window.VelantisNombres.nombre(p.name):p.name;
    document.getElementById('lhsDesc').textContent=p.long||p.desc||'';
    var opt=document.getElementById('lhsOptions'), price=document.getElementById('lhsPrice');
    var giftBtn=document.getElementById('lhsGiftBtn'), giftNote=document.getElementById('lhsGiftNote');
    var giftMode=false; try{giftMode=localStorage.getItem('velantis_oilgift')==='1';}catch(e){}
    sel.gift=false;
    if(p.kind==='difusor'){
      /* 3-sep: el difusor se cobra por aroma incluido. Si el mapa trae la lista
   (cx.difusorAromas), la ficha la ofrece como pastillas y el carrito lo
   nombra «<difusor> · <aroma>», que es la llave con la que se cobra. */
 var CXD={}; try{ CXD=JSON.parse(document.getElementById('pc-conexion').textContent)||{}; }catch(e){}
 var aromas=(CXD.difusorAromas||{})[p.name]||[];
 sel.aroma=aromas[0]||'';
 var aromH=aromas.length? '<div class="lhs-sizes"><div class="lhs-sizes-l">Elige el aroma incluido</div><div class="lhs-pills lhs-pills-aroma">'+
   aromas.map(function(a,i){ return '<button type="button" class="lhs-pill'+(i===0?' on':'')+'" data-aroma="'+esc(a)+'">'+esc(a)+'</button>'; }).join('')+'</div></div>' : '';
 opt.innerHTML=aromH+'<ul class="lhs-specs">'+(p.specs||[]).map(function(s){return '<li>'+esc(s)+'</li>';}).join('')+'</ul>';
 if(aromas.length && CXD.precios && CXD.precios[p.name+' · '+sel.aroma]!=null) p.price=+CXD.precios[p.name+' · '+sel.aroma];
 else if(CXD.precios && CXD.precios[p.name]!=null) p.price=+CXD.precios[p.name]; /* 4-sep: difusor sin aromas, precio del mapa */
      sel.price=p.price||1500; sel.ml='';
      price.innerHTML=money(sel.price)+' <small>MXN</small>';
      if(giftBtn) giftBtn.hidden=true; if(giftNote) giftNote.hidden=true;
      document.getElementById('lhsAdd').textContent='Agregar al carrito';
    } else if(p.kind==='ambiental'){
      if(giftBtn) giftBtn.hidden=true; if(giftNote) giftNote.hidden=true;
      var pyrH='';
      if(p.pyr && p.pyr.some(function(x){return x;})){ var tr=[['Salida',0],['Corazón',1],['Fondo',2]];
        pyrH='<div class="lhs-pyr">'+tr.map(function(t){return p.pyr[t[1]]?'<div class="lhs-pyr-row"><span class="lhs-pyr-l">'+t[0]+'</span><span class="lhs-pyr-n">'+esc(p.pyr[t[1]])+'</span></div>':'';}).join('')+'</div>'; }
      opt.innerHTML=pyrH+'<div class="lhs-ml250">Aroma de ambiente · 250&nbsp;ml · con feromonas incluidas</div>';
      /* 4-sep: precio del mapa por nombre exacto; 449 solo si el mapa no lo trae */
      var CXA={}; try{ CXA=JSON.parse(document.getElementById('pc-conexion').textContent)||{}; }catch(e){}
      sel.price=(CXA.precios && CXA.precios[p.name]!=null)? +CXA.precios[p.name] : 449; sel.ml='250 ml';
      price.innerHTML=money(sel.price)+' <small>MXN</small>';
      document.getElementById('lhsAdd').textContent='Agregar al carrito';
    } else {
      if(giftBtn) giftBtn.hidden=true;
      var sizes=p.sizes||[['100 ml',450],['250 ml',900],['1 L',2200]];
      /* 4-sep: los tamanos del aceite toman su precio del mapa vivo («<nombre> · Aceite <tamano>»); la tabla fija queda de respaldo */
      (function(){ var CXO={}; try{ CXO=JSON.parse(document.getElementById('pc-conexion').textContent)||{}; }catch(e){} var P=CXO.precios||{};
        sizes=sizes.map(function(sz){ var v=P[p.name+' · Aceite '+sz[0]]; return v!=null? [sz[0],+v] : sz; }); })();
      if(giftMode){ sizes=[['100 ml',0]]; sel.gift=true; }
      var notesHTML='';
      if(p.pyr && p.pyr.some(function(x){return x;})){
        var tiers=[['Salida',0],['Corazón',1],['Fondo',2]];
        notesHTML='<div class="lhs-pyr">'+tiers.map(function(t){ return p.pyr[t[1]]?'<div class="lhs-pyr-row"><span class="lhs-pyr-l">'+t[0]+'</span><span class="lhs-pyr-n">'+esc(p.pyr[t[1]])+'</span></div>':''; }).join('')+'</div>';
      } else if(p.notes){ notesHTML='<div class="lhs-notes"><span class="lhs-notes-l">Notas</span>'+esc(p.notes)+'</div>'; }
      opt.innerHTML=notesHTML+'<div class="lhs-sizes"><div class="lhs-sizes-l">'+(sel.gift?'Tu regalo':'Elige tu tamaño')+'</div><div class="lhs-pills">'+
        sizes.map(function(s,i){return '<button type="button" class="lhs-pill'+(i===0?' on':'')+'" data-price="'+s[1]+'" data-ml="'+esc(s[0])+'">'+esc(s[0])+'<span>'+(sel.gift?'GRATIS':money(s[1]))+'</span></button>';}).join('')+'</div></div>';
      sel.price=sizes[0][1]; sel.ml=sizes[0][0];
      if(sel.gift){
        price.innerHTML='GRATIS <small>· 100&nbsp;ml de regalo</small>';
        if(giftNote){ giftNote.hidden=false; giftNote.innerHTML='🎁 Estás eligiendo tu <b>aceite de regalo</b> (100&nbsp;ml gratis) por la compra de tu difusor. Selecciónalo y agrégalo.'; }
        document.getElementById('lhsAdd').textContent='Agregar aceite de regalo';
      } else {
        price.innerHTML=money(sel.price)+' <small>MXN</small>';
        if(giftNote) giftNote.hidden=true;
        document.getElementById('lhsAdd').textContent='Agregar al carrito';
      }
    }
    // acordeón
    document.getElementById('lhsAcc').innerHTML=
      (p.areas? acc('Áreas recomendadas', p.areas) : '')+
      acc('Envíos y devoluciones','Envío a todo México. Preparamos tu pedido en 24–48 h. Cambios dentro de los primeros 7 días con el producto sin abrir.');
    window.scrollTo(0,0);
  }
  function acc(t,b){ return '<div class="lhs-ai"><button class="lhs-ai-h" type="button">'+esc(t)+'<span>+</span></button><div class="lhs-ai-b">'+esc(b)+'</div></div>'; }

  // interacción: pills, acordeón, agregar
  page.addEventListener('click',function(e){
    var pa=e.target.closest('.lhs-pill[data-aroma]');
 if(pa){ [].forEach.call(page.querySelectorAll('.lhs-pill[data-aroma]'),function(x){x.classList.remove('on');}); pa.classList.add('on'); sel.aroma=pa.getAttribute('data-aroma'); return; }
 var pill=e.target.closest('.lhs-pill');
    if(pill){ [].forEach.call(page.querySelectorAll('.lhs-pill'),function(x){x.classList.remove('on');}); pill.classList.add('on');
      sel.price=+pill.getAttribute('data-price'); sel.ml=pill.getAttribute('data-ml');
      document.getElementById('lhsPrice').innerHTML=(sel.gift?'GRATIS <small>· 100&nbsp;ml de regalo</small>':money(sel.price)+' <small>MXN</small>'); return; }
    var ah=e.target.closest('.lhs-ai-h'); if(ah){ ah.parentNode.classList.toggle('open'); return; }
    if(e.target.closest('#lhsGiftBtn')){ try{localStorage.setItem('velantis_oilgift','1');}catch(e){} location.hash='#/aceites'; return; }
    if(e.target.closest('#lhsAdd')){
      if(sel.gift){
        if(window.VelantisCart) window.VelantisCart.add({name:sel.base+' · Aceite 100 ml (Regalo)', price:0, img:sel.img, sub:'Aceite de regalo · 100 ml · por tu difusor'});
        try{localStorage.removeItem('velantis_oilgift');}catch(e){}
        document.getElementById('lhsAdd').textContent='¡Regalo agregado! ✓';
        if(window.VelantisCart&&window.VelantisCart.open) window.VelantisCart.open();
        return;
      }
      var name=sel.kind==='difusor'? (sel.aroma? sel.base+' · '+sel.aroma : sel.base) : (sel.kind==='ambiental'? sel.base : (sel.base+' · Aceite '+sel.ml));
      var sub=sel.kind==='difusor'? ('Difusor · aroma incluido'+(sel.aroma?': '+sel.aroma:'')) : (sel.kind==='ambiental'? 'Aroma de ambiente · 250 ml' : ('Aceite para difusor · '+sel.ml));
      if(window.VelantisCart) window.VelantisCart.add({name:name, price:sel.price, img:sel.img, sub:sub});
      var b=document.getElementById('lhsAdd'), t=b.textContent; b.textContent='Agregado ✓'; setTimeout(function(){b.textContent=t;},1400);
    }
  });

  function route(){
    var hs=location.hash||'';
    var isL=hs.indexOf('#/lhs/')===0;
    document.body.classList.toggle('lhs',isL);
    if(page) page.hidden=!isL;
    if(isL){ render(decodeURIComponent(hs.slice('#/lhs/'.length))); }
  }
  window.addEventListener('hashchange',route);
  if(document.readyState!=='loading') route(); else document.addEventListener('DOMContentLoaded',route);
})();
;
/* index-39 */

/* ===== VELANTIS_DGIFT — pop-up 100 ml gratis en difusores ===== */
(function(){
  var t=document.getElementById('dgiftToast'), x=document.getElementById('dgiftX');
  if(!t) return; var timer=null, closedFor='';
  function show(){ clearTimeout(timer); t.classList.add('show'); timer=setTimeout(hide,9000); }
  function hide(){ clearTimeout(timer); t.classList.remove('show'); }
  if(x) x.addEventListener('click',function(){ closedFor=location.hash; hide(); });
  function onRoute(){ if(/^#\/difusores\/?$/.test(location.hash||'')){ if(closedFor!==location.hash) setTimeout(show,700); } else hide(); }
  window.addEventListener('hashchange',onRoute);
  if(document.readyState!=='loading') onRoute(); else document.addEventListener('DOMContentLoaded',onRoute);
})();
;
/* index-40 */

/* ===== VELANTIS_AMB — ficha de ambiental (sin SKU, Inspirado en, descripción) ===== */
(function(){
  var DESCS={"Vidanta":"Inspirado en los resorts Vidanta de Nuevo Vallarta, México. Un aroma elegante de flores blancas y maderas, sinónimo de lujo mexicano.","Vidanta Luxxe":"Inspirado en Grand Luxxe de Vidanta, la categoría más exclusiva de sus resorts en Nuevo Vallarta. Cítricos, azahar y maderas nobles.","Atelier":"Inspirado en los hoteles Atelier de Playa Mujeres, México. Una firma aromática y refinada, sofisticada y cálida.","Wynn":"Inspirado en el Wynn Las Vegas y su icónico aroma de lobby. Cítricos frescos y flores blancas sobre un fondo lujoso.","Aria":"Inspirado en el ARIA Resort de Las Vegas. Una firma cítrica y elegante, moderna y luminosa como su arquitectura.","MGM":"Inspirado en el MGM Grand de Las Vegas. Cítricos, especias y maderas en una firma vibrante y lujosa.","Hard Rock":"Inspirado en los Hard Rock Hotels. Un aroma con carácter —cuero, tabaco y maderas— que evoca energía y actitud.","Bvlgari Tokyo":"Inspirado en el Bulgari Hotel Tokyo, en Ginza, Japón. Una firma serena de té verde, yuzu y bambú con elegancia zen.","Royal Champagne":"Inspirado en el Royal Champagne Hotel & Spa, en la región de Champagne, Francia. Uva, cítricos y flores blancas, efervescente.","Xcaret":"Inspirado en el Hotel Xcaret México, en la Riviera Maya. Un aroma cítrico y tropical que celebra el Caribe mexicano.","Xcaret Parque":"Inspirado en el Parque Xcaret, en la Riviera Maya. Cítricos, brisa marina y coco que capturan la frescura del Caribe.","Innova Sport":"Inspirado en las tiendas Innova Sport. Un aroma fresco y enérgico de cítricos, menta y maderas para espacios dinámicos.","Palacio":"Inspirado en la elegancia de un gran hotel palacio. Un aroma señorial y sofisticado que viste tu espacio con lujo clásico.","Zara Home":"Inspirado en el aroma de Zara Home. Flor de algodón, ámbar y vainilla que envuelven el hogar con calidez minimalista.","Muy Mucho":"Inspirado en las tiendas Muy Mucho, la marca española de hogar y decoración. Un aroma frutal y floral, alegre y acogedor.","Mahogany Teakwood":"Inspirado en el icónico \"Mahogany Teakwood\" de Bath & Body Works. Caoba, teca y cuero: cálido, amaderado y adictivo.","Emwa":"Inspirado en las joyerías EMWA. Un aroma refinado de flores blancas y maderas suaves, discreto y elegante.","Lincoln":"Un aroma de ambiente exclusivo de Velantis: cedro dulce, ámbar y maderas cálidas que envuelven tu espacio con elegancia acogedora.","Abercrombie":"Inspirado en el aroma Fierce de Abercrombie & Fitch. Fresco, amaderado y masculino, con la energía de sus tiendas.","Santal 33":"Inspirado en el legendario Santal 33 de Le Labo, Nueva York. Sándalo cremoso, cardamomo y cuero: un aroma de culto.","Bergamote 22":"Inspirado en Bergamote 22 de Le Labo. Bergamota y pomelo radiantes sobre un fondo almizclado y luminoso.","Baccarat":"Inspirado en Baccarat Rouge 540. Azafrán, jazmín y ámbar en una firma opulenta y luminosa.","Lime Basil & Mandarin":"Inspirado en Lime Basil & Mandarin de Jo Malone London. Lima, albahaca y mandarina: fresco, herbal y sofisticado.","Aventus":"Inspirado en Aventus de Creed. Audaz y elegante: piña, abedul y almizcle que impregnan tu espacio de sofisticación.","Tobacco Vanille":"Inspirado en Tobacco Vanille de Tom Ford. Tabaco, vainilla y especias en una firma cálida, opulenta y envolvente.","Erba Pura":"Inspirado en Erba Pura de Xerjoff. Frutas dulces, cítricos y ámbar en un aroma vibrante y luminoso.","Layton":"Inspirado en Layton de Parfums de Marly. Manzana, lavanda y vainilla en una firma elegante y adictiva.","Frenesí":"Un aroma de ambiente frutal y floral, intenso y seductor, que llena tu espacio de energía.","Organs":"Un aroma de ambiente sofisticado de bergamota, flores y maderas, elegante y envolvente.","The Noir 29":"Inspirado en The Noir 29 de Le Labo. Té negro, higo y tabaco: un aroma enigmático, oscuro y sofisticado.","Car New":"Inspirado en el aroma a auto nuevo. Cítricos, cuero fresco y maderas que transmiten la sensación de lo recién estrenado.","Leather":"Un aroma de cuero noble, ámbar y tabaco: cálido, elegante y con carácter.","Té Negro Le Labo":"Inspirado en el Thé Noir 29 de Le Labo. Té negro, higo y tabaco en una firma enigmática y refinada.","Maderas del Mediterráneo":"Inspirado en las maderas del Mediterráneo. Cedro, ciprés y romero que evocan la brisa y el bosque mediterráneo.","Lino y Aloe":"Un aroma limpio y sereno de lino fresco y aloe, con flores blancas y almizcle. Frescura acogedora para el hogar.","Ámbar Cedro":"Un aroma cálido de ámbar y cedro con vainilla y almizcle. Envolvente y reconfortante.","Japanese Lotus":"Inspirado en la flor de loto japonesa. Té verde, bambú y almizcle en un aroma zen, limpio y sereno.","White Tea":"Inspirado en el té blanco. Flores blancas, almizcle y cítricos en una firma limpia, ligera y elegante."};
  function CAT(){ return window.VELANTIS_CAT||[]; }
  function reg(){ window.VELANTIS_LHS=window.VELANTIS_LHS||{}; return window.VELANTIS_LHS; }
  function build(){
    var r=reg(), cat=CAT(); if(!cat.length) return false;
    cat.forEach(function(row){
      if(row[1]!=='Ambiental') return;
      var name=row[0], pyr=[row[5]||'',row[6]||'',row[7]||''];
      var desc=DESCS[name]||('Inspirado en '+name+'. Un aroma de ambiente exclusivo para perfumar tu espacio, con feromonas incluidas.');
      var f=row[3]||''; var eb=(f && !/ambiental/i.test(f))?(f+' · Ambiental'):'Ambiental';
      r['AMB:'+name]={ name:name, kind:'ambiental', eyebrow:eb, img:'amb-img', pyr:pyr,
        notes:pyr.filter(Boolean).join(', '), desc:desc, long:desc };
    });
    return true;
  }
  if(!build()){ var n=0, iv=setInterval(function(){ if(build()||++n>40) clearInterval(iv); },100); }
})();
;
/* index-41 */

/* ===== VELANTIS_AMB_GROUPED — ambientales agrupados por colección ===== */
(function(){
  var COLS={"Hoteles":["VIDANTA","VIDANTALUXXE","ATELIER","WYNN","ARIA","MGM","HARDROCK","BVLGARITOKYO","ROYALCHAMPAGNE","XCARET","XCARETPARQUE"],"Tiendas":["INNOVASPORT","PALACIO","ZARAHOME","MUYMUCHO","MAHOGANYTEAKWOOD","EMWA","LINCOLN","ABERCROMBIE"],"Perfume":["SANTAL33","BERGAMOTE22","BACCARAT","LIMEBASILMANDARIN","AVENTUS","TOBACCOVANILLE","ERBAPURA","LAYTON","FRENESI","ORGANS","THENOIR29"],"Otros":["CARNEW","LEATHER","TENEGROLELABO","MADERASDELMEDITERRANEO","LINOYALOE","AMBARCEDRO","JAPANESELOTUS","WHITETEA"]};
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function norm(s){ return String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toUpperCase().replace(/[^A-Z0-9]/g,''); }
  function CAT(){ return window.VELANTIS_CAT||[]; }
  function colOf(name){ var n=norm(name); for(var k in COLS){ if(COLS[k].indexOf(n)>=0) return k; } return 'Otros'; }
  function card(r,col){
    var name=r[0], notes=[r[5],r[6],r[7]].filter(Boolean).join(', ');
    return '<article class="oil-card" data-lhs="'+esc('AMB:'+name)+'" data-name="'+esc(name)+'" data-price="449" data-img="amb-img" data-sub="Aroma de ambiente · 250 ml" tabindex="0">'+
      '<div class="oil-img amb-card-img"></div>'+
      '<div class="oil-body"><div class="oil-cat">'+esc(col)+'</div><h3>'+esc(name)+'</h3>'+
      '<p class="oil-desc">Aroma de ambiente · 250 ml</p>'+
      (notes?'<p class="oil-notes">'+esc(notes.charAt(0).toUpperCase()+notes.slice(1))+'</p>':'')+
      '<div class="oil-price">$449 <small>MXN</small></div>'+
      '<button class="add" type="button">Agregar al carrito</button></div></article>';
  }
  function render(){
    var box=document.getElementById('ambCatalog'); if(!box) return;
    var amb=CAT().filter(function(r){return r[1]==='Ambiental';});
    var order=['Hoteles','Tiendas','Perfume','Otros'], groups={};
    amb.forEach(function(r){ var c=colOf(r[0]); (groups[c]=groups[c]||[]).push(r); });
    box.innerHTML=order.map(function(col){
      var list=groups[col]||[]; if(!list.length) return '';
      return '<div class="oil-group"><div class="oil-group-s">Colección</div><h3 class="oil-group-h">'+col+'</h3>'+
        '<div class="oil-grid">'+list.map(function(r){return card(r,col);}).join('')+'</div></div>';
    }).join('');
    /* 4-sep: las tarjetas nacen con opacidad 0 y esperan la clase v-listo, que
       index-46 pone cuando el motor resuelve su hueco. Al entrar por navegacion
       (la rejilla se redibuja) esa senal no llegaba y la coleccion se veia vacia.
       Aqui se marcan por su cuenta. */
    setTimeout(function(){ var v=box.querySelectorAll('.oil-card:not(.v-listo)'); for(var i=0;i<v.length;i++) v[i].classList.add('v-listo'); }, 400);

    if(!box._wired){ box._wired=1; box.addEventListener('click',function(e){
      if(e.target.closest('.add')) return;
      var c=e.target.closest('.oil-card'); if(!c) return;
      location.hash='#/lhs/'+encodeURIComponent(c.getAttribute('data-lhs'));
    }); }
  }
  var cIv=null, cCur=0;
  function carousel(){
    var car=document.getElementById('ambCarousel'); if(!car) return;
    var slides=car.querySelectorAll('.ambc-slide'), dots=car.querySelectorAll('.ambc-dot');
    if(slides.length<2){ return; }
    function go(i){ cCur=(i+slides.length)%slides.length;
      [].forEach.call(slides,function(s,k){ s.classList.toggle('on',k===cCur); });
      [].forEach.call(dots,function(dd,k){ dd.classList.toggle('on',k===cCur); }); }
    function restart(){ clearInterval(cIv); cIv=setInterval(function(){ go(cCur+1); },5000); }
    if(!car._wired){ car._wired=1;
      [].forEach.call(dots,function(dd){ dd.addEventListener('click',function(){ go(+dd.getAttribute('data-i')); restart(); }); });
      car.addEventListener('mouseenter',function(){ clearInterval(cIv); });
      car.addEventListener('mouseleave',restart);
    }
    restart();
  }
  function route(){
    var isA=/^#\/ambientales\/?$/.test(location.hash||'');
    document.body.classList.toggle('ambgrouped',isA);
    var pg=document.getElementById('ambientalesPage'); if(pg) pg.hidden=!isA;
    if(isA){ render(); carousel(); window.scrollTo(0,0); } else { clearInterval(cIv); }
  }
  window.addEventListener('hashchange',route);
  if(document.readyState!=='loading') route(); else document.addEventListener('DOMContentLoaded',route);
})();
;
/* index-42 */

/* ===== VELANTIS_DIFGIFT — aceite 100 ml gratis por cada difusor en el carrito ===== */
(function(){
  var box=document.getElementById('cartDifGift'), itemsEl=document.getElementById('cartItems');
  if(!box||!itemsEl) return;
  function build(){
    var difusores=0, regalos=0;
    [].forEach.call(itemsEl.querySelectorAll('.ci'), function(ci){
      var nm=(ci.querySelector('.ci-name')||{}).textContent||'';
      var sub=(ci.querySelector('.ci-sub')||{}).textContent||'';
      var q=(ci.querySelector('.ci-qty span')||{}).textContent||'1'; q=parseInt(q,10)||1;
      if(/difusor/i.test(sub) && !/aceite/i.test(sub)) difusores+=q;      // difusor (aroma incluido)
      if(/\(Regalo\)/i.test(nm) || /aceite de regalo/i.test(sub)) regalos+=q;
    });
    if(difusores<=0){ box.hidden=true; box.innerHTML=''; return; }
    box.hidden=false;
    var pend=Math.max(0, difusores-regalos);
    if(pend>0){
      box.innerHTML='<div class="cdg-item"><span class="cdg-ic">🎁</span>'+
        '<div class="cdg-info"><b>Aceite de regalo por tu difusor</b>'+
        '<span>'+(pend>1?('Puedes elegir '+pend+' aceites de 100\u00A0ml GRATIS'):'Elige tu aceite de 100\u00A0ml — GRATIS')+'</span></div>'+
        '<button class="cdg-btn" type="button">Elegir aceite →</button></div>';
    } else {
      box.innerHTML='<div class="cdg-item done"><span class="cdg-ic">✅</span>'+
        '<div class="cdg-info"><span class="cdg-done-t">Aceite de regalo agregado</span>'+
        '<span>Disfruta tu 100\u00A0ml de cortesía por tu difusor.</span></div></div>';
    }
  }
  box.addEventListener('click',function(e){
    if(!e.target.closest('.cdg-btn')) return;
    try{localStorage.setItem('velantis_oilgift','1');}catch(err){}
    if(window.VelantisCart&&window.VelantisCart.close) window.VelantisCart.close();
    location.hash='#/aceites';
  });
  new MutationObserver(build).observe(itemsEl, {childList:true, subtree:true});
  build();
})();
;
/* index-43 */

/* ============================================================================
   PUENTE · el motor de escena dentro del sitio
   ----------------------------------------------------------------------------
   El sitio pinta cada imagen de producto como un <div class="cat-img n-xxx">
   con un fondo CSS. Este puente los localiza, averigua de que fragancia son y
   les monta encima la escena del motor.

   No toca una linea del sitio ni del motor: solo los junta. Si se quita este
   bloque, el sitio vuelve a sus fotos de familia.
   ========================================================================== */
(function(){
  var DPR = Math.min(2, Math.max(1, window.devicePixelRatio || 1));

  /* NITIDEZ EN CELULAR (reportado el 1-sep: «se ve super borroso el frasco
     en formato celular»).

     El lienzo de la ficha se dibujaba siempre a 760 px de lado. En un
     telefono con pantalla de alta densidad esa ficha ocupa unos 1170 px
     REALES: cada pixel dibujado se pintaba sobre 1.5, y en los de 3x sobre
     2.3. No era compresion ni la foto: era resolucion.

     Se multiplica por la densidad de la pantalla, con tope de 2. El tope
     importa: un lienzo es memoria viva —lado x lado x 4 bytes— y sin freno
     un telefono modesto se queda sin ella. A 2x la ficha son 1520 px, que
     cubre de sobra cualquier telefono actual.

     Las TARJETAS del catalogo se quedan en 380 a proposito: hay cientos
     montadas a la vez y subirlas multiplicaria la memoria por cuatro. Su
     mejora pide antes soltar las que ya no se ven, que es otro trabajo. */
  /* 380 era la resolucion de una pantalla de densidad 1. En un telefono
     la misma tarjeta ocupa el doble o el triple de pixeles reales, y el
     dibujo se estiraba x2.05. Ver fusionar.py, paso 8. */
  var LADO       = Math.round(380 * DPR);
  var LADO_FICHA = Math.round(760 * DPR);
  var MAPA       = JSON.parse(document.getElementById("pm-mapa").textContent);
  var LAMINA_DE  = JSON.parse(document.getElementById("pm-lamina").textContent);
  var LAMINAS    = JSON.parse(document.getElementById("pm-laminas").textContent);
  /* El catalogo de espacio —aceites y ambientales— comparte motor con el
     perfume pero NO comparte envase: va en el atomizador ambar de 250 ml.
     Aqui vienen los indices que llevan ese frasco y el frasco mismo; se
     cambia `CAPAS.fra` justo antes de dibujarlos y se devuelve despues.
     Los difusores no entran: son aparatos, y su foto de producto es la
     correcta. */
  var ESPACIO   = JSON.parse(document.getElementById("pm-espacio").textContent);
  var GENERO    = JSON.parse(document.getElementById("pm-genero").textContent);
  var REAL      = JSON.parse(document.getElementById("pm-colorreal").textContent);
  var MAPA_ACE  = JSON.parse(document.getElementById("pm-mapaace").textContent);
  var MAPA_AMB  = JSON.parse(document.getElementById("pm-mapaamb").textContent);
  var FRASCOS_ESP = JSON.parse(document.getElementById("pm-frascos").textContent);
  var IMG_ESP={};

  var IMG={}, LISTO=false, OBS=null, MUT=null, ANIM={};

  function norm(s){
    return String(s||"").normalize("NFD").replace(/[̀-ͯ]/g,"")
      .toLowerCase().replace(/[^a-z0-9]+/g," ").trim();
  }

  /* --------------------------------------------------- las dos geometrias
     Es el esquema aprobado: en reposo las notas van DETRAS del frasco,
     apretadas en su area, y al pasar el raton salen a un anillo que le deja
     aire alrededor. El frasco se pinta siempre encima, asi que en reposo
     solo asoma lo que sobresale por los lados. */
  var DENTRO=(function(){
    var pos=[[42,38],[58,37],[40,58],[60,57],[50,30],
             [50,72],[45,46],[55,47],[43,66],[57,65]];
    var tam=[0.46,0.44,0.42,0.45,0.38,0.40,0.36,0.35,0.39,0.37];
    var out=[];
    for(var k=0;k<10;k++)
      out.push({x:pos[k][0], y:pos[k][1], ang:(k*37)%360, tam:tam[k],
                forma:(k%2===0)?"larga":"libre", sangra:false});
    return out;
  })();
  var DONA=(function(){
    var cx=50, cy=50, rx=47, ry=45, out=[];   // aire alrededor del frasco
    var tam=[1.00,0.55,0.82,0.52,0.95,0.50,0.86,0.54,0.90,0.51,0.80,0.56];
    for(var k=0;k<12;k++){
      var a=(k/12)*Math.PI*2 - Math.PI/2;
      out.push({x:+(cx+Math.cos(a)*rx).toFixed(1),
                y:+(cy+Math.sin(a)*ry).toFixed(1),
                ang:+((a*180/Math.PI)+90).toFixed(0),
                tam:tam[k], forma:(k%2===0)?"larga":"libre",
                sangra:(k%2===0)});
    }
    return out;
  })();
  function ranurasEn(t){
    var out=[];
    for(var i=0;i<DONA.length;i++){
      var a=DENTRO[i%DENTRO.length], b=DONA[i];
      out.push({x:a.x+(b.x-a.x)*t, y:a.y+(b.y-a.y)*t,
                ang:a.ang+(b.ang-a.ang)*t,
                tam:a.tam+(b.tam-a.tam)*t,
                forma:b.forma, sangra:(t>0.55)?b.sangra:false});
    }
    return out;
  }

  /* Los controles del panel del motor, puestos en su sitio ANTES de cada
     lectura. Se fijaban una sola vez al arrancar, y bastaba con que el sitio
     o el propio motor repintaran algo para que volvieran a su valor de
     fabrica: a partir de ahi `opciones()` devolvia otra cosa y las escenas
     salian con fondo, con vidrio y con otro tamano de frasco. Se notaba al
     volver por segunda vez a la rejilla, que es cuando el motor ya repinto.
     Fijarlos en cada dibujo cuesta cuatro asignaciones. */
  function fijarPanel(){
    var va=document.getElementById("va");
    if(va && va.value!=="frag") va.value="frag";
    var uf=document.getElementById("uf");
    if(uf) uf.checked=false;      // el fondo lo pinta el puente, no el motor
    var cx=document.getElementById("cx");
    if(cx) cx.checked=false;
    var va2=document.getElementById("va2");
    if(va2) va2.checked=true;     // el frasco trae su propio alfa
    var tf=document.getElementById("tf");
    if(tf && tf.value!=="74") tf.value=74;
  }

  /* ------------------------------------------------------------- dibujo */
  var TMP=null;
  function dibujarEscena(cv, idx, t){
    if(typeof RANURAS==="undefined") return;

    /* EL ENVASE VA PRIMERO, antes de `variante()`. ESPACIO trae el envase de
       cada indice: «amb» el atomizador, «ace» el frasco alto, «gen_h» la
       etiqueta azul, «gen_m» la vino; sin entrada se usa el que trae el
       motor, que es la negra del unisex.

       El orden no es un detalle. `variante()` resuelve la escena leyendo
       CAPAS.fra, asi que cambiar el frasco DESPUES no tiene ningun efecto:
       se dibujaba siempre el de fabrica. */
    var cual = ESPACIO[idx];
    var im = cual && IMG_ESP[cual];
    var esp = im && im.width;
    /* El frasco original se guarda en una variable LOCAL. Antes era global y
       compartida: dos escenas dibujandose en el mismo instante —dos tarjetas
       animandose a la vez— podian pisarsela y una devolvia el frasco de la
       otra, dejando CAPAS.fra apuntando a un envase que no era. A partir de
       ahi todo lo que se dibujara salia con el frasco equivocado. */
    var fraOriginal = null;
    if(esp){ fraOriginal = CAPAS.fra; CAPAS.fra = [{img:im}]; }

    RANURAS.length=0; ranurasEn(t).forEach(function(r){ RANURAS.push(r); });
    fijarPanel();          // antes de leer, siempre
    var o=opciones();
    var v=variante(idx, o, (document.getElementById("sem")||{}).value||"velantis");
    var g=cv.getContext("2d"), S=cv.width;
    g.clearRect(0,0,S,S);
    if(!TMP) TMP=document.createElement("canvas");
    if(TMP.width!==S){ TMP.width=TMP.height=S; }
    var gp=TMP.getContext("2d"); gp.clearRect(0,0,S,S);
    try{
      /* `separar` va SIEMPRE a cero. Dispara `apartarDelFrasco`, que expulsa
         del area del frasco justo a las piezas que queremos detras; y su
         bucle de sesenta vueltas no es continuo respecto al parametro, asi
         que interpolarlo hacia saltar las piezas en el ultimo fotograma. El
         anillo ya viene repartido por construccion. */
      dibujar(gp, S, v.semilla, {...v.o, soloProps:true, sinGrado:true,
                                 particulas:(v.o.particulas||0)*t, separar:0});
      g.drawImage(TMP,0,0);                        // las piezas
      pintarFrasco(g, S, {...v.o, sinGrado:true}); // y el frasco encima
    }catch(e){
      /* un catch mudo aqui costo una sesion entera de diagnostico: la
         escena salia en blanco y no habia forma de saber por que */
      if(!window.__pmErr){
        window.__pmErr = String(e && e.message).slice(0, 200);
      }
    }
    /* y se devuelve SIEMPRE, pase lo que pase en el dibujo */
    if(esp) CAPAS.fra = fraOriginal;
  }
  /* La lamina no se tapa con un velo: se GRADUA. `globalCompositeOperation`
     en "color" toma el tono y la saturacion del relleno y conserva la
     luminosidad de la foto, que es exactamente lo que hace un color grading
     de cine: el papel sigue teniendo su textura, sus dobleces y su luz, pero
     ahora es del color de la fragancia.

     Un degradado encima habria sido un parche de color flotando sobre una
     foto que sigue siendo beige. Esto cambia la foto. */
  function dibujarFondo(cv, lam, tinte){
    var g=cv.getContext("2d"), S=cv.width, im=IMG[lam];
    g.save();
    g.globalCompositeOperation = "source-over";
    g.clearRect(0,0,S,S);
    if(im){
      /* A GRIS PRIMERO. La lamina de acuarela es rosada, y el modo "color"
         respeta la luminosidad pero se pelea con la saturacion que ya trae:
         graduar un rosa hacia verde da un verde sucio tirando a rosa. Sin
         color propio, el tono que se pide es el tono que sale. */
      g.filter = "grayscale(1) contrast(1.06) brightness(1.03)";
      g.drawImage(im,0,0,S,S);
      g.filter = "none";
    }
    if(im && tinte){
      /* FUERZA DEL GRADO. A 0.9 el fondo quedaba pintado, no graduado: en
         las familias saturadas —ambarina, citrica, frutal— la tarjeta se
         volvia un cartel de color y el frasco perdia contra el fondo. A
         0.58 el papel conserva su propio gris y el color se lee como luz
         de ambiente, que es lo que tiene que ser: un fondo. */
      g.globalCompositeOperation = "color";
      g.globalAlpha = 0.58;
      g.fillStyle = tinte;
      g.fillRect(0,0,S,S);
      /* un punto de calor al centro, donde va el frasco, para que el grado
         no aplane la foto en un solo tono */
      g.globalCompositeOperation = "soft-light";
      g.globalAlpha = 0.26;
      var rad = g.createRadialGradient(S*0.5,S*0.44,0, S*0.5,S*0.44,S*0.62);
      rad.addColorStop(0, tinte);
      rad.addColorStop(1, "rgba(0,0,0,0)");
      g.fillStyle = rad;
      g.fillRect(0,0,S,S);
    }
    g.restore();
  }

  function animar(caja, idx, hacia){
    var esc=caja.querySelector("canvas.escena"); if(!esc) return;
    var a=ANIM[idx+"|"+(caja.dataset.pmId||"")]||(ANIM[idx+"|"+(caja.dataset.pmId||"")]={t:0,raf:0});
    if(a.raf) cancelAnimationFrame(a.raf);
    var desde=a.t, ini=null, dur=(hacia>a.t)?560:520;
    a.raf=requestAnimationFrame(function paso(ahora){
      if(ini===null) ini=ahora;
      var k=Math.min(1,(ahora-ini)/dur);
      /* La misma curva de ida y de vuelta, invertida. Al salir, exponencial:
         arranca de golpe y frena, que es como se ve una explosion. Al volver,
         del reves, para que las piezas se recojan en vez de salir disparadas
         hacia dentro. Con `out` en los dos sentidos el regreso parecia otra
         explosion. */
      var e=(hacia>desde) ? (k===1?1:1-Math.pow(2,-9*k))
                          : (k===0?0:Math.pow(2,-9*(1-k)));
      a.t=desde+(hacia-desde)*e;
      dibujarEscena(esc, idx, a.t);
      if(k<1) a.raf=requestAnimationFrame(paso); else a.raf=0;
    });
  }

  /* De que fragancia es este hueco. En el catalogo el nombre esta en el
     `data-name` de la tarjeta; en la ficha, en #ppName. */
  function nombreDe(el){
    /* En aceites y ambientales el nombre limpio esta en `data-lhs` —el
       `data-name` de la tarjeta trae pegado el formato: «Vidanta · Aceite
       100 ml»—. En su ficha, en #lhsName. */
    var lhs=el.closest("[data-lhs]");
    if(lhs && lhs.dataset.lhs) return lhs.dataset.lhs.replace(/^AMB:/,"");
    if(el.id==="lhsImg"){
      var ln=document.getElementById("lhsName");
      if(ln) return ln.textContent;
    }
    var host=el.closest("[data-name]");
    if(host && host.dataset.name) return host.dataset.name;
    if(el.id==="ppImg"){
      /* 3-sep: el titulo visible ya dice «Inspirado en Fico Di Amalfi, de
         Acqua di Parma»; el nombre crudo del producto vive en data-nombre del
         h1 y en data-name de #ppInfo. Leer el texto del h1 dejaba al motor
         sin formula y la ficha caia a la foto fija por familia. */
      var info=document.getElementById("ppInfo");
      if(info && info.dataset.name) return info.dataset.name;
      var n=document.getElementById("ppName");
      if(n) return n.dataset.nombre || n.textContent;
    }
    var art=el.closest("article,.card,.cat-card");
    if(art){
      var h=art.querySelector("h3,h2,.cat-card h3");
      if(h) return h.textContent;
    }
    return "";
  }

  /* ------------------------------------------------- la luz de la escena
     El promedio de los colores de las notas, en RGB y pesado por presencia
     igual que lo hace el motor: `(p/100)^3`. El cubo importa —sin el, una
     nota de fondo al 46 % tira tanto como la cabeza al 100 % y todo acaba
     en el mismo pardo.

     Despues se aclara y se satura. Un promedio crudo de ocho notas cae casi
     siempre en un cafe apagado: es fiel a la suma y no se parece a ninguna
     de las notas. Lo que se busca es la luz que echaria esa fragancia, no
     su promedio contable. */
  /* DE DONDE SALE EL TONO. Dos criterios, y no dan lo mismo:

       "notas"    el promedio de los colores de SUS notas. Cada fragancia
                  distinta de su vecina, pero dentro de una familia los
                  tonos se parecen y a veces se cruzan.
       "familia"  el tono que el motor ya tiene asignado a las 12 familias
                  —citrica 52, marina 203, floral 342...—. Mas legible como
                  sistema: todas las marinas azules, todas las florales
                  rosas; a cambio, doce colores para 579 fragancias.

     Se cambia aqui. El resto del puente no se entera. */
  var CRITERIO = "familia";

  /* EL FONDO POR FAMILIA.

     No se usa el `tono` de COLOR_FAMILIA tal cual. Ese juego esta hecho para
     tenir las notas dentro de la escena, y medido sobre el catalogo deja
     SIETE familias dentro de 36 grados —frutal 6, especiada 16, cuero 20,
     amaderada 26, gourmand 30, ambarina 40, almizclada 42—: como fondo se
     verian todas del mismo naranja.

     Aqui se separan tambien por saturacion y luz, que es como se distingue
     una madera de un ambar en la vida real: no por el tono, por la
     profundidad. El cuero es oscuro y apagado, el ambar es encendido, el
     almizcle es palido y casi neutro. Mismo tono, lecturas distintas. */
  var FONDO_FAMILIA = {
    citrica:    "hsl(52,62%,66%)",   // amarillo abierto
    verde:      "hsl(104,42%,60%)",  // hoja
    aromatica:  "hsl(78,38%,60%)",   // herbal
    marina:     "hsl(203,52%,64%)",  // azul
    frutal:     "hsl(352,58%,66%)",  // rojo de fruta
    floral:     "hsl(330,44%,71%)",  // rosa claro
    gourmand:   "hsl(28,60%,62%)",   // caramelo
    especiada:  "hsl(10,52%,56%)",   // rojo de especia
    amaderada:  "hsl(30,30%,50%)",   // madera, apagada y media
    ambarina:   "hsl(40,68%,60%)",   // ambar encendido
    cuero:      "hsl(16,40%,44%)",   // oscuro
    almizclada: "hsl(44,16%,69%)"    // palido, casi neutro
  };

  function tonoDeFamilia(frag){
    if(typeof familiaDe !== "function") return null;
    return FONDO_FAMILIA[familiaDe(frag)] || null;
  }

  /* EL GENERO CORRIGE EL FONDO.

     La familia sale de votar los acordes, y muchos perfumes de caballero
     votan floral —jazmin, azahar y rosa son estructura de fondo en media
     perfumeria masculina— asi que al pasar el raton por la coleccion de
     hombre se encendian rosas y violetas brillantes.

     No se cambia la familia: eso seria mentir sobre la formula. Se cambia
     como se ILUMINA: en caballero el rosa y el violeta se llevan a su
     equivalente calido y todo baja de luz, que es la diferencia real entre
     una version masculina y una femenina del mismo acorde —profundidad, no
     otro ingrediente—. En dama sube la luz. Unisex se queda como esta. */
  function porGenero(hsl, gen){
    if(!hsl || gen === "u") return hsl;
    var m = /hsl\((-?[\d.]+),\s*([\d.]+)%,\s*([\d.]+)%\)/.exec(hsl);
    if(!m) return hsl;
    var h = (parseFloat(m[1]) + 360) % 360,
        s = parseFloat(m[2]), l = parseFloat(m[3]);
    if(gen === "h"){
      /* La banda rosa-violeta —285 a 360— se lleva a AZUL CLARO. El ambar
         que habia antes resolvia el rosa pero dejaba la coleccion de
         caballero en un solo bloque naranja, porque las familias calidas ya
         ocupan casi todo lo demas. El azul separa de verdad y es el otro
         extremo del circulo, asi que el contraste entre una tarjeta y su
         vecina se lee de un vistazo. */
      if(h >= 285 || h <= 5){
        var d = h >= 285 ? (h - 285) : (h + 75);   // 0..80 dentro de la banda
        h = 196 + d * 0.20;                         // 196..212, azul claro
        s = Math.min(Math.max(s, 34), 46);
        l = Math.min(72, Math.max(l, 62));          // claro, como se pidio
        return "hsl(" + h.toFixed(0) + "," + s.toFixed(0) + "%,"
                      + l.toFixed(0) + "%)";
      }
      s = s * 0.86;
      l = Math.max(38, l - 11);      // mas hondo
    }else{
      l = Math.min(78, l + 4);
      s = Math.min(72, s * 1.04);
    }
    return "hsl(" + h.toFixed(0) + "," + s.toFixed(0) + "%," + l.toFixed(0) + "%)";
  }

  /* CUANTO COLOR: lo dice la fotografia, no la paleta.

     `REAL` trae, por ranura, el color promedio MEDIDO sobre las 76 fotos de
     ingrediente del motor: pixel a pixel, pesando por alfa. Un ambar da 74 %
     de saturacion y un acuatico da 7 %, porque asi son las fotos.

     Para una fragancia se promedian esos colores reales —pesados por
     presencia, `(p/100)^3`— y se toma la saturacion del promedio. Eso hace
     dos cosas de golpe:

       · una fragancia de citricos y ambar sale encendida; una de almizcle
         y acuatico sale casi neutra. Ya no es un techo plano para todas.
       · si las notas se pelean en color, el promedio se apaga solo. Una
         formula coherente da fondo vivo; una dispersa, fondo sobrio. Eso
         no hubo que programarlo: sale de promediar.

     El TONO sigue viniendo de la familia y del genero. Esto solo decide la
     intensidad. */
  var SAT_MIN = 8, SAT_MAX = 46;

  function satReal(acordes){
    if(!acordes || !acordes.length) return null;
    var r=0, g=0, b=0, peso=0;
    for(var i=0;i<acordes.length;i++){
      var c = REAL[acordes[i].s];
      if(!c) continue;
      var w = Math.pow((acordes[i].p==null?100:acordes[i].p)/100, 3);
      /* de vuelta a RGB para promediar donde el promedio significa algo */
      var hh=c.h/360, ll=c.l/100, ss=c.s/100;
      var q = ll < 0.5 ? ll*(1+ss) : ll+ss-ll*ss, pp = 2*ll-q;
      function ca(tt){ tt=(tt+1)%1;
        return tt<1/6 ? pp+(q-pp)*6*tt : tt<1/2 ? q
             : tt<2/3 ? pp+(q-pp)*(2/3-tt)*6 : pp; }
      r += ca(hh+1/3)*w; g += ca(hh)*w; b += ca(hh-1/3)*w; peso += w;
    }
    if(!peso) return null;
    r/=peso; g/=peso; b/=peso;
    var mx=Math.max(r,g,b), mn=Math.min(r,g,b), l=(mx+mn)/2, d=mx-mn;
    var s = d===0 ? 0 : d/(1-Math.abs(2*l-1));
    return Math.max(SAT_MIN, Math.min(SAT_MAX, s*100*1.15));
  }

  function calmar(hsl, acordes){
    if(!hsl) return hsl;
    var m = /hsl\((-?[\d.]+),\s*([\d.]+)%,\s*([\d.]+)%\)/.exec(hsl);
    if(!m) return hsl;
    var medida = satReal(acordes);
    var s = medida != null ? medida
                           : Math.min(SAT_MAX, parseFloat(m[2]) * 0.74);
    return "hsl(" + m[1] + "," + s.toFixed(0) + "%," + m[3] + "%)";
  }

  function tinteDe(frag, idx){
    if(!frag) return null;
    var c = (CRITERIO === "familia") ? (tonoDeFamilia(frag) || luzDe(frag.a))
                                     : (luzDe(frag.a) || tonoDeFamilia(frag));
    return calmar(porGenero(c, GENERO[idx] || "u"), frag.a);
  }

  function luzDe(acordes){
    if(!acordes || !acordes.length) return null;
    var r=0, g=0, b=0, peso=0;
    for(var i=0;i<acordes.length;i++){
      var a=acordes[i], c=a.c || a.color;
      if(!c) continue;
      var h=String(c).replace("#","");
      if(h.length===3) h=h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
      var n=parseInt(h,16); if(isNaN(n)) continue;
      var w=Math.pow((a.p==null?100:a.p)/100, 3);
      r+=((n>>16)&255)*w; g+=((n>>8)&255)*w; b+=(n&255)*w; peso+=w;
    }
    if(!peso) return null;
    r/=peso; g/=peso; b/=peso;

    /* a HSL para poder subir el color sin cambiar el tono */
    var mx=Math.max(r,g,b)/255, mn=Math.min(r,g,b)/255, l=(mx+mn)/2, d=mx-mn;
    var s=d===0?0:d/(1-Math.abs(2*l-1));
    var hh=0;
    if(d!==0){
      var R=r/255,G=g/255,B=b/255;
      hh = mx===R ? ((G-B)/d + (G<B?6:0)) : mx===G ? ((B-R)/d+2) : ((R-G)/d+4);
      hh*=60;
    }
    /* EXPANSION DE GAMA, la misma tecnica que usa el motor para graduar.
       Medido sobre las 409 del sitio: el promedio crudo mete 366 en la
       misma banda naranja —citricos, maderas, vainillas y ambares son todos
       calidos, asi que ser fiel al ingrediente ES ser monotono— y todas las
       tarjetas se encendian del mismo color, que era justo lo contrario de
       lo que se busca.

       Esto no inventa el orden, lo estira: lo que era mas rojo sigue siendo
       mas rojo, solo que ahora se nota. Con k=2.4 el catalogo ocupa 10 de
       las 12 franjas de tono en vez de 3. */
    var CENTRO = 34, K = 2.4;
    var dd = hh - CENTRO;
    while(dd >  180) dd -= 360;
    while(dd < -180) dd += 360;
    hh = (CENTRO + dd * K + 720) % 360;

    s = Math.min(0.72, s*1.55 + 0.14);   // que se distinga de sus vecinas
    l = Math.min(0.74, Math.max(0.52, l*0.45 + 0.42));  // luz, no pigmento
    return "hsl(" + hh.toFixed(0) + "," + (s*100).toFixed(0) + "%,"
                  + (l*100).toFixed(0) + "%)";
  }

  /* Los alias de los Best Sellers se retiraron junto con `.card .foto`:
     solo servian para que esas cuatro tarjetas escritas a mano encontraran
     su formula, y ahora conservan su fotografia original. El problema de
     fondo sigue ahi y es del dev: esas cuatro no salen del catalogo, asi
     que no tienen SKU ni precio y no se pueden vender desde la portada. */
  var contador=0;
  function montar(el){
    if(!LISTO || el.dataset.pmHecho) return;
    var nom=norm(nombreDe(el));
    /* De que catalogo es ESTE hueco. El nombre no basta: «Vidanta» existe
       como perfume, como aceite y como ambiental, y cada uno va en su
       envase. Se decide por donde esta montado:

         .oil-img ................. tarjeta de aceite
         .amb-img / data-img=n-amb  tarjeta de ambiental
         #lhsImg .................. la ficha; lo dice su enlace de volver
         el resto ................. catalogo de perfume                    */
    var mapa = MAPA;
    var tarjeta = el.closest("[data-img]");
    var marca = tarjeta ? (tarjeta.getAttribute("data-img") || "") : "";
    var lhs = el.closest("[data-lhs]");
    var ref = lhs ? (lhs.getAttribute("data-lhs") || "") : "";

    /* CUIDADO CON EL ORDEN. El dev reutilizo la rejilla de aceites para los
       ambientales, asi que las DOS tarjetas llevan la clase `oil-img`:

           <div class="oil-img oil-ph">        aceite
           <div class="oil-img amb-card-img">  ambiental

       Preguntar por `oil-img` primero mandaba los sesenta ambientales al
       mapa de aceites y salian con el frasco alto transparente. Lo
       especifico va antes que lo general: la marca de ambiental —su clase
       propia, su `data-img` o el prefijo AMB: de su ficha— se resuelve
       primero, y solo si no la lleva se trata como aceite. */
    if(el.classList.contains("amb-card-img") ||
       el.classList.contains("amb-img") ||
       marca === "amb-img" || /^n-amb/.test(marca) ||
       /^AMB:/.test(ref)){
      mapa = MAPA_AMB;
    }else if(el.classList.contains("oil-img")){
      mapa = MAPA_ACE;
    }else if(el.id === "lhsImg"){
      var atras = document.getElementById("lhsBack");
      var h = atras ? (atras.getAttribute("href") || "") : "";
      mapa = /aceites/.test(h) ? MAPA_ACE : MAPA_AMB;
    }
    var idx = mapa[nom];
    if(idx == null && mapa !== MAPA) idx = MAPA[nom];   // ultimo recurso
    if(idx==null) return;                    // sin formula: se queda su foto
    el.dataset.pmHecho="1";
    /* para que nombre se dibujo: si el hueco se reutiliza con otro
       producto, hay que volver a dibujarlo. Ver el barrido. */
    el.dataset.pmNom=nom;
    el.dataset.pmId=(++contador);
    el.classList.add("con-motor");
    var S=(el.id==="ppImg"||el.id==="lhsImg"||el.classList.contains("rl-spotlight-motor"))?LADO_FICHA:LADO;
    el.insertAdjacentHTML("beforeend",
      '<canvas class="fondo"  width="'+S+'" height="'+S+'"></canvas>'+
      '<canvas class="escena" width="'+S+'" height="'+S+'"></canvas>');
    var tinte = tinteDe((typeof FRAGANCIAS !== "undefined")
                        ? FRAGANCIAS[idx] : null, idx);
    dibujarFondo(el.querySelector("canvas.fondo"), LAMINA_DE[nom]||"acuarela", tinte);

    /* Dos huecos se ven ABIERTOS desde el principio, sin pasar el raton: la
       imagen de la ficha —que es la pantalla donde se decide— y las tarjetas
       de «fragancias similares». Estas ultimas, ademas, porque en reposo las
       notas van detras del frasco y seis seguidas en fila se leian como seis
       fotos iguales. Abiertas, cada una ensena su propia formula. */
    /* Tercero: las tarjetas de «Recomendados de temporada» (comentario 15-sep): se
       ven abiertas, con las notas y el fondo, igual que al pasar el raton. */
    var abierta = (el.id==="ppImg") || (el.id==="lhsImg")
            || el.classList.contains("pp-simimg")
            || !!(el.closest && el.closest("section.season"));
    var disp=el.closest(".cat-card,article,.card")||el;
    if(abierta){
      ANIM[idx+"|"+el.dataset.pmId]={t:1,raf:0};
      dibujarEscena(el.querySelector("canvas.escena"), idx, 1);
    }else{
      dibujarEscena(el.querySelector("canvas.escena"), idx, 0);
      /* 28-sep: el indice queda apuntado en el hueco para que el oyente de
         toque —que vive en el documento, no aqui— sepa que escena abrir. */
      el.dataset.pmIdx = idx;
      disp.addEventListener("mouseenter",function(){ animar(el,idx,1); });
      disp.addEventListener("mouseleave",function(){ animar(el,idx,0); });

    }
  }

  /* DONDE SI Y DONDE NO.

     El motor entra en el catalogo y en la ficha, que es donde la persona
     compara y decide y donde las ocho fotos de familia repetidas hacian
     dano de verdad.

     NO entra en los heros ni en las secciones fijas de la portada
     —Temporada, Novedades 2026, Best Sellers—, que usan `.card .foto`. Ahi
     va la fotografia original: son piezas compuestas, con su encuadre y su
     luz, y una escena generada al lado se ve peor, no mejor. */
  var SEL=".cat-img, .pp-img, .pp-simimg, "+
          ".oil-img, .amb-img, #lhsImg";

  /* SOLTAR LO QUE YA NADIE VE.

     Cada lienzo es memoria viva: lado x lado x 4 bytes. Al subir el lado de
     380 a 760 esa memoria se cuadruplica, y medido en el sitio llegaban a
     estar montados 26 lienzos a la vez (14.3 MB) aunque solo CUATRO cupieran
     en pantalla. A 760 eso serian 57 MB, demasiado para un telefono modesto:
     por eso el 1-sep las tarjetas se dejaron en 380 y se anoto que su mejora
     pedia antes soltar las que se van. Esto es ese trabajo.

     Se monta a 1500 px de distancia (rootMargin del observador) y se suelta
     a partir de 2600. La diferencia entre los dos numeros es a proposito:
     sin esa holgura, una tarjeta parada en el borde se montaria y soltaria
     sin parar mientras el dedo tiembla.

     Soltar es quitarle los lienzos y la clase. No hace falta nada mas: el
     barrido ya sabe que un hueco con `pmHecho` pero sin lienzo hay que
     volver a montarlo —es la reparacion del «se ve bien la primera vez y a
     la segunda se rompe»—, asi que al volver se dibuja solo. */
  var LEJOS = 2600;
  function soltarLejanos(){
    var v = document.querySelectorAll(".cat-img[data-pm-hecho]");
    for(var i = 0; i < v.length; i++){
      var el = v[i];
      if(el.id === "ppImg" || el.id === "lhsImg") continue;   // la ficha se queda
      if(!el.querySelector("canvas")) continue;
      var r = el.getBoundingClientRect();
      var fuera = (r.top > window.innerHeight + LEJOS) || (r.bottom < -LEJOS);
      if(!fuera) continue;
      var cs = el.querySelectorAll("canvas");
      for(var j = 0; j < cs.length; j++){
        cs[j].width = cs[j].height = 0;    // libera el respaldo del lienzo
        cs[j].remove();
      }
      el.classList.remove("con-motor");
      if(el.dataset.pmId) delete ANIM[el.dataset.pmId];
    }
  }

  function barrer(){
    if(!LISTO) return;
    soltarLejanos();
    var v=document.querySelectorAll(SEL);
    for(var i=0;i<v.length;i++){
      var el=v[i];

      /* EL HUECO QUE PIERDE SU CLASE.

         Al repintar la ficha el sitio reescribe `className` entero, y con
         eso borra `con-motor` —pero `data-pmHecho` sobrevive, porque es un
         atributo aparte—. El resultado: los canvas siguen ahi, ya sin
         `position:relative` que los sujete, asi que se salen del hueco y
         tapan media pagina; y por debajo reaparece la foto de familia.

         Era el «se ve bien la primera vez y a la segunda se rompe». Aqui
         se detecta y se repara: si el lienzo sigue puesto basta devolver
         la clase; si tambien se lo llevaron, se monta de nuevo. */
      if(el.dataset.pmHecho){

        /* EL HUECO QUE CAMBIA DE PRODUCTO.

           `#ppImg` es UN solo elemento que la ficha reutiliza. Al abrir el
           segundo perfume el sitio le reescribe la clase, pero `pmHecho`
           sobrevive y el lienzo del primero sigue puesto: el motor lo daba
           por hecho y no volvia a dibujar. Se veian el nombre y las notas
           del segundo con la escena del primero.

           Se compara con el nombre para el que se dibujo. Si cambio, se
           tiran los lienzos y se monta de nuevo. En las tarjetas del
           catalogo el nombre nunca cambia, asi que esto no las toca. */
        if(el.dataset.pmNom && el.dataset.pmNom !== norm(nombreDe(el))){
          delete el.dataset.pmHecho;
          delete el.dataset.pmNom;
          var viejos=el.querySelectorAll("canvas");
          for(var q=0;q<viejos.length;q++) viejos[q].parentNode.removeChild(viejos[q]);
          el.classList.remove("con-motor");
          if(OBS) OBS.observe(el); else montar(el);
          continue;
        }

        if(!el.classList.contains("con-motor")){
          if(el.querySelector("canvas.escena")){
            el.classList.add("con-motor");
          }else{
            delete el.dataset.pmHecho;
            if(OBS) OBS.observe(el); else montar(el);
          }
        }
        continue;
      }
      if(OBS) OBS.observe(el); else montar(el);
    }
  }

  function arrancarObservadores(){
    if("IntersectionObserver" in window){
      OBS=new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(e.isIntersecting){ montar(e.target); OBS.unobserve(e.target); }
        });
      },{rootMargin:"1500px"});
    }
    /* El sitio repinta al filtrar, al buscar y al cambiar de ruta: hay que
       volver a barrer cada vez que cambia el DOM. */
    MUT=new MutationObserver(function(){
      clearTimeout(MUT._t); MUT._t=setTimeout(barrer,80);
    });
    MUT.observe(document.body,{childList:true,subtree:true});
    barrer();

    /* Y se insiste. El observador de interseccion depende de que el
       navegador calcule posiciones, y en una pagina de 16 MB que sigue
       montando cosas eso llega tarde o no llega: el resultado era una
       rejilla con las fotos de familia repetidas, como si el puente no
       existiera. Un barrido cada segundo y medio durante el primer par de
       minutos cuesta nada y quita el problema de raiz. */
    var repasos = 0;
    var reloj = setInterval(function(){
      barrer();
      if(++repasos > 80) clearInterval(reloj);   // dos minutos
    }, 1500);
    window.addEventListener("scroll", function(){
      clearTimeout(barrer._s); barrer._s = setTimeout(barrer, 90);
    }, {passive:true});
  }

  function listoElMotor(){
    return typeof dibujar==="function" && typeof opciones==="function"
        && typeof variante==="function" && typeof CAPAS!=="undefined"
        && CAPAS.tex && CAPAS.tex.length;
  }
  /* La espera. 400 intentos a 120 ms son 48 segundos, y con la pagina en
     16 MB el motor tarda mas que eso en tener su kit listo: el puente se
     rendia justo antes y la pagina se quedaba sin una sola escena. Diez
     minutos de margen no cuestan nada —son un setTimeout que se apaga solo
     en cuanto el kit aparece— y cubren un equipo lento o una tableta. */
  var n=0;
  (function esperar(){
    if(!listoElMotor()){
      if(++n>5000){ console.warn("[puente] el motor no cargo su kit"); return; }
      return setTimeout(esperar,120);
    }
    fijarPanel();
    var va=document.getElementById("va");
    if(va) va.dispatchEvent(new Event("change"));
    CAPAS.fon=[];

    var falta=0;
    Object.keys(FRASCOS_ESP).forEach(function(k){
      falta++;
      var im=new Image();
      im.onload=im.onerror=function(){ IMG_ESP[k]=im; if(--falta===0) listo(); };
      im.src=FRASCOS_ESP[k];
    });
    Object.keys(LAMINAS).forEach(function(k){
      falta++;
      var im=new Image();
      im.onload=im.onerror=function(){ IMG[k]=im; if(--falta===0) listo(); };
      im.src=LAMINAS[k];
    });
    if(!falta) listo();

    function listo(){
      if(LISTO) return;
      LISTO=true;
      arrancarObservadores();
      /* un reporte que se puede leer desde la consola: `__puente()` */
      window.__puente = function(forzar){
        var v = document.querySelectorAll(SEL), sin = [], con = 0, err = null;
        for(var i=0;i<v.length;i++){
          if(v[i].dataset.pmHecho){ con++; continue; }
          if(sin.length < 5){
            var nm = nombreDe(v[i]);
            sin.push({clase:v[i].className.slice(0,26), nombre:nm,
                      norm:norm(nm), enMapa:MAPA[norm(nm)] != null,
                      visible:v[i].getBoundingClientRect().top});
          }
        }
        if(forzar){
          try{ montar(v[forzar-1] || v[0]); }
          catch(e){ err = e.message; }
        }
        var fr = {};
        Object.keys(IMG_ESP).forEach(function(k){
          fr[k] = IMG_ESP[k] ? (IMG_ESP[k].width + "x" + IMG_ESP[k].height +
                                (IMG_ESP[k].complete ? " ok" : " incompleta"))
                             : "null"; });
        return {listo:LISTO, huecos:v.length, montados:con, intentos:n,
                hayObservador:!!OBS, enMapa:Object.keys(MAPA).length,
                errorAlForzar:err, frascos:fr,
                declarados:Object.keys(FRASCOS_ESP),
                error:window.__pmErr || null, muestra:sin};
      };
      /* ------------------------------------------------- el toque, delegado
     En un telefono no hay raton: el navegador solo finge `mouseenter` cuando
     el dedo se queda apretado, y entonces el efecto —las notas abriendose en
     anillo alrededor del frasco— practicamente no se veia.

     Va delegado en el documento a proposito. Colgarlo de cada tarjeta al
     montarla no aguanta: las tiras de cada casa se rellenan solas al
     acercarse y el nodo se reemplaza, dejando el oyente colgado de un
     elemento que ya no existe. Asi hay uno solo y da igual cuanto se
     redibuje.

     No se cierra al levantar el dedo: el efecto es el que hay que ver. */
  document.addEventListener("touchstart", function(ev){
    var t = ev.target;
    if(!t || !t.closest) return;
    var hueco = t.closest("[data-pm-idx]");
    if(!hueco) return;
    var idx = +hueco.dataset.pmIdx;
    if(isNaN(idx)) return;
    var tarjeta = hueco.closest(".cat-card,article,.card") || hueco;
    if(tarjeta.classList.contains("cc-tocada")) return;   /* ya esta abierta */
    tarjeta.classList.add("cc-tocada");
    try{ animar(hueco, idx, 1); }catch(e){}
  }, {passive:true, capture:true});

  console.log("[puente] motor montado ·",
                  Object.keys(MAPA).length,"fragancias con escena");
    }
  })();
})();
